// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:33:36.843Z
// Property: Coffee Creek (ID: 6767906449167036)
// Collections: 29 amenities, 6 floorplans (live), 45 photos, 68 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449167036",
  "property_external_id": "50523",
  "property_zillow_url": "https://www.zillow.com/apartments/owasso-ok/coffee-creek/5ZbRv4/",
  "property_apartments_url": "https://www.apartments.com/coffee-creek-area-edmond-ok/",
  "property_google_business_url": "https://www.google.com/maps/place/Coffee+Creek+Apartments/data=!4m2!3m1!1s0x0:0xc5e9556968f84884?sa=X&ved=2ahUKEwiQwq-agYOTAxWwkokEHXRUDwkQ_BJ6BAgQEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/posts/mikeskurko_eve-maler-and-i-got-to-meet-up-at-blue-bottle-activity-7478563227749011456-QJNv",
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "coffee-creek",
  "property_name": "Coffee Creek",
  "property_website_url": "https://www.caseusa.com/apartments/ok/owasso/coffee-creek/",
  "property_domain": null,
  "property_address": "14100 E. 106th St. North",
  "property_full_address": "14100 E. 106th St. North, Owasso, OK, 74055",
  "property_address_1": "14100 E. 106th St. North",
  "property_address_2": null,
  "property_address_city": "Owasso",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74055",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": null,
  "property_address_latitude": "36.3072",
  "property_address_longitude": "-95.8142",
  "property_email": "coffeecreek@caseusa.com",
  "property_phone": "(539) 200-6510",
  "property_call_tracking_phone": "855-643-1576",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Coffee Creek in Owasso, OK, where comfort meets convenience. Our thoughtfully designed one- and two-bedroom apartments boast modern amenities like a swimming pool, 24-hour fitness center, and a welcoming onsite dog park. Enjoy gatherings in our picnic area or relax in your spacious apartment with vaulted ceilings. Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Coffee Creek, an inviting apartment community nestled in the heart of Owasso, OK. Discover the perfect blend of comfort and convenience with our spacious one and two-bedroom floor plans, designed to suit your lifestyle. Each home features modern touches such as energy-efficient appliances, large walk-in closets, and the option of a cozy fireplace or vaulted ceilings* for an added touch of elegance. \n\nAt Coffee Creek, you'll enjoy an array of exceptional amenities tailored for your enjoyment and relaxation. Start your day with a workout in our state-of-the-art 24-hour fitness center or unwind at our sparkling swimming pool. Host friends and family in our picnic area complete with barbecue grills, or take advantage of our pet-friendly policies with an onsite dog park for your furry companions. \n\nOur vibrant resident clubhouse and community courtyard offer perfect settings for socializing and lounging. You’ll also benefit from our professional management staff, 24-hour emergency maintenance, and courtesy patrol, ensuring a safe and well-maintained environment. With convenient features like electronic payments, package receiving, and garage availability, we provide a hassle-free living experience.\n\nExperience the charm and comfort of Coffee Creek. With easy access to all that Owasso has to offer, you won't want to miss out on this opportunity. Find your new home today—browse our availability or schedule a tour to visit our community! It’s time to welcome your new lifestyle!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-836d-745e-943a-4c666041e42b.webp",
  "property_featured_image_media": {
    "alt_text": "View of the Tulsa skyline with lush green landscaping in the foreground.",
    "public_id": "019cfb50-836d-745e-943a-4c666041e42b",
    "storage_key": "property/6767906449167036/019cfb50-836d-745e-943a-4c666041e42b.webp",
    "width": 1456,
    "height": 473
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "2",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of two pets per household.",
  "property_pet_policy_description": "Above applies to Pets up to 40 pounds;; Above applies to Pets up 80 pounds- 40 pounds",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://coffeecreekapartmentsowasso.securecafe.com/onlineleasing/coffee-creek/floorplans.aspx",
  "property_resident_portal_url": "https://coffeecreekapartmentsowasso.securecafe.com/residentservices/coffee-creek/userlogin.aspx",
  "property_apply_now_url": "https://coffeecreekapartmentsowasso.securecafe.com/onlineleasing/coffee-creek/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-6f09-76ff-b975-cbfb7eee4bfb.webp",
  "property_primary_logo_media": {
    "alt_text": "The Park at Coffee Creek Luxury Apartments logo",
    "public_id": "019cfb50-6f09-76ff-b975-cbfb7eee4bfb",
    "storage_key": "property/6767906449167036/019cfb50-6f09-76ff-b975-cbfb7eee4bfb.webp",
    "width": 2647,
    "height": 1665
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb51-5407-7699-9987-af061f07b2bb.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Park at Coffee Creek Luxury Apartments logo.",
    "public_id": "019cfb51-5407-7699-9987-af061f07b2bb",
    "storage_key": "property/6767906449167036/019cfb51-5407-7699-9987-af061f07b2bb.webp",
    "width": 640,
    "height": 403
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb51-621e-718a-a273-3188d1d9acce.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Park at Coffee Creek Luxury Apartments logo",
    "public_id": "019cfb51-621e-718a-a273-3188d1d9acce",
    "storage_key": "property/6767906449167036/019cfb51-621e-718a-a273-3188d1d9acce.webp",
    "width": 640,
    "height": 403
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#827466",
  "property_secondary_color": "#3d3d3f",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#d1c7b8",
  "property_color_5": "#549ec9",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1108",
  "property_sqft_min": "789",
  "property_sqft_max": "1108",
  "property_price_range": "1109 - 1459",
  "property_price_min": "1109",
  "property_price_max": "1459",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/CoffeeCreekOwasso/photos/d41d8cd9/1384450673691526/",
  "property_instagram_url": "https://www.instagram.com/coffeecreekowasso/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJjUYCQB36tocRhEj4aGlV6cU",
  "property_youtube_url": "https://www.youtube.com/watch?v=JbJe37BvEto&vl=en",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Owasso%2C+OK+74055",
  "property_tiktok_url": "https://www.tiktok.com/@coffeecreekapartments?_r=1&_t=ZT-95oPpPpwhOH",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Coffee Creek",
  "property_home_romance_title": "Experience the Joy of Living in Your Dream Apartment!",
  "property_home_amenities_blurb": "Welcome to Coffee Creek in Owasso, OK—where comfort meets style! Choose from spacious one and two-bedroom floor plans, all featuring modern amenities like gourmet kitchens and large walk-in closets. Unwind in our swimming pool, socialize in the clubhouse, or enjoy a barbecue in our picnic area. Your new home awaits!",
  "property_home_floorplans_blurb": "Welcome to Coffee Creek in Owasso, OK, where your ideal living space awaits. With a variety of thoughtfully designed floor plans, each apartment home harmonizes comfort and style. Embrace community vibes while enjoying modern amenities. Take a moment to browse our available options and find the perfect fit for your lifestyle!",
  "property_home_gallery_blurb": "At Coffee Creek in Owasso, OK, find your perfect floor plan—one or two bedrooms tailored for comfort. Enjoy modern amenities like a sparkling swimming pool, onsite dog park, and a welcoming clubhouse. Picture yourself soaking in the sun, grilling in the picnic area, or unwinding in your spacious apartment!",
  "property_home_neighborhood_blurb": "At Coffee Creek in Owasso, OK, your vibrant lifestyle awaits. Nestled near the Owasso Library and Airtopia Adventure Park, you’re steps away from adventure and relaxation. With convenient access to top-notch facilities like The Home Depot and Reasor's, life here is both easy and exciting. Find your perfect haven today!",
  "property_home_reviews_blurb": "At Coffee Creek in Owasso, OK, community comes alive! Residents rave about the \"welcoming atmosphere and friendly neighbors.\" This serene haven offers comfort and connection in every corner. Curious about life at Coffee Creek? Dive into our resident reviews and see the vibrant community that makes us truly special!",
  "property_neighborhood_blurb": "Nestled in the heart of Owasso, Coffee Creek offers convenient access to vibrant community hotspots. Enjoy nearby parks like Centennial Park and Rayola Park, or engage in fun at Airtopia Adventure Park. Discover unique amenities from The Home Depot to The Owasso Library—all just steps away from stylish one and two-bedroom apartments.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Nestled in Owasso, OK, Coffee Creek blends comfort and style with spacious one- and two-bedroom floor plans. Enjoy leisurely afternoons in our picnic area, invigorate yourself at the 24-hour fitness center, or unwind by the swimming pool. Experience a lifestyle where convenience meets community, and embrace your new home today!",
  "property_applynow_blurb": "At Coffee Creek in Owasso, OK, your ideal home awaits! Choose from spacious one and two-bedroom floor plans featuring gourmet kitchens and enticing amenities like a picnic area, 24-hour fitness center, and pet-friendly dog park. Embrace comfort and convenience—lease your new apartment online today!",
  "property_contactus_blurb": "At Coffee Creek in Owasso, OK, your ideal living space awaits! With thoughtfully designed one and two-bedroom floor plans, you’ll find the perfect ambiance to call home. Have questions? Contact our leasing team today for personalized assistance and discover the comforts of your new apartment community!",
  "property_faqs_blurb": "At Coffee Creek in Owasso, OK, we offer thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Have questions? Our FAQs page is your guide to understanding the perks of our vibrant community, from amenities to leasing details. Dive in and find the answers you seek!",
  "property_floorplans_blurb": "At Coffee Creek in Owasso, OK, your ideal home awaits! Choose from our thoughtfully designed one and two-bedroom floor plans, each tailored to fit your lifestyle. Embrace comfort and style—exploring our options is the first step toward living your best life in our welcoming community!",
  "property_gallery_blurb": "At Coffee Creek in Owasso, OK, picture a vibrant lifestyle with spacious one and two-bedroom apartments featuring gourmet kitchens, vaulted ceilings, and cozy fireplaces. Enjoy sunny picnics at the barbecue area, chill by the swimming pool, or unwind at the onsite dog park. Your perfect home awaits!",
  "property_interactivemap_blurb": "At Coffee Creek in Owasso, OK, your ideal living space awaits! Choose from spacious one- and two-bedroom floor plans, complete with modern amenities like a dog park, 24-hour fitness center, and gourmet kitchens. Navigate your future home effortlessly with our interactive community map today!",
  "property_pets_blurb": "At Coffee Creek in Owasso, OK, your furry friends are part of the family! With no weight restrictions and space for up to two pets, your cats and dogs can roam freely. Enjoy a vibrant community where pets thrive alongside you, making every day a tail-wagging adventure!",
  "property_referafriend_blurb": "At Coffee Creek in Owasso, OK, your perfect home awaits with inviting one- and two-bedroom floor plans tailored just for you. Enrich your living experience by sharing this haven—great friends make great neighbors! Refer a friend today and let’s create a vibrant community together!",
  "property_residentaccess_blurb": "Welcome to Coffee Creek in Owasso, OK, where comfort meets convenience. Our thoughtfully designed one-bedroom and two-bedroom floor plans cater to your lifestyle. Sign in to the resident portal for easy rent payments, maintenance scheduling, and access to exclusive community updates. Your seamless living experience starts here!",
  "property_reviews_blurb": "At Coffee Creek in Owasso, OK, residents are raving about their vibrant community. One happy tenant shared, “Living here feels like home—friendly neighbors and beautiful surroundings!” Dive into our reviews to see what else our residents love about life at Coffee Creek! Your perfect apartment awaits!",
  "property_created_at": "1770655176566",
  "property_scheduletour_blurb": "At Coffee Creek in Owasso, OK, we offer spacious one and two-bedroom floor plans tailored to your lifestyle. Experience contemporary living surrounded by lush landscapes. Curious about community life? Check out what our residents say and schedule a tour today to envision your new home!",
  "property_thankyou_blurb": "Thank you for reaching out to Coffee Creek in Owasso, OK! Our diverse floor plans, featuring cozy one-bedroom and spacious two-bedroom options, are tailored to fit your lifestyle. Keep an eye on your inbox—our dedicated team will connect with you soon to help you find your perfect home sweet home.",
  "property_virtualtours_blurb": "At Coffee Creek in Owasso, OK, our thoughtfully designed one and two-bedroom apartments offer the perfect blend of comfort and style. Envision your ideal space as you navigate our virtual tour, showcasing the inviting interiors and vibrant community. Ready to find your perfect home? Join us online today!",
  "property_copyright": "2026 All Rights Reserved. Coffee Creek",
  "property_seo_title_home": "Coffee Creek |  Apartments in Owasso, OK",
  "property_seo_description_home": "Discover your oasis at Coffee Creek, Owasso, OK! Stylish one and two-bedroom apartments with pool, dog park, and top-notch amenities await!",
  "property_seo_title_floorplans": "Floor Plans | Owasso, OK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Coffee Creek in Owasso, OK. Choose from stylish one and two-bedroom floor plans designed for comfort and convenience.",
  "property_seo_title_amenities": "Amenities | Owasso, OK Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at Coffee Creek in Owasso! Enjoy a luxury pool, pet-friendly park, and stunning apartment features. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Owasso, OK",
  "property_seo_description_gallery": "Capture your dream lifestyle at Coffee Creek, Owasso! View stunning amenities, from a luxurious pool to a pet-friendly dog park. Picture your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Coffee Creek Apartments",
  "property_seo_description_virtualtours": "Experience Coffee Creek in Owasso, OK! Take a virtual tour of our stylish one and two-bedroom apartments and see your future home today!",
  "property_seo_title_interactivemap": "Interactive Map | Coffee Creek Apartments",
  "property_seo_description_interactivemap": "Find your perfect oasis at Coffee Creek in Owasso, OK! Use our interactive map to explore spacious floor plans, pet-friendly amenities, and more.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Owasso, OK",
  "property_seo_description_neighborhood": "Experience the charm of Owasso at Coffee Creek. Enjoy your ideal one or two-bedroom apartment while savoring local hotspots and vibrant community life!",
  "property_seo_title_contact": "Contact Us | Coffee Creek",
  "property_seo_description_contact": "Reach out to Coffee Creek in Owasso, OK! Whether it’s a cozy one-bedroom or spacious two-bedroom, our leasing team is ready to assist you today.",
  "property_seo_title_faqs": "FAQs | Apartments in Owasso, OK",
  "property_seo_description_faqs": "Find answers to your questions about Coffee Creek in Owasso, OK! Learn about our pet-friendly community, amenities, and floor plans. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Owasso, OK",
  "property_seo_description_reviews": "Experience life at Coffee Creek in Owasso, OK! Read resident reviews and see why our pet-friendly community, fitness center, and pool create a welcoming home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Owasso, OK",
  "property_seo_description_applynow": "Discover your ideal home at Coffee Creek, Owasso, OK. Enjoy pet-friendly living, spacious layouts, and great amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Coffee Creek",
  "property_seo_description_residentaccess": "Log in to Coffee Creek's resident portal in Owasso, OK! Pay rent, request maintenance, and stay connected to community updates—your home at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Coffee Creek",
  "property_seo_description_referafriend": "Refer a friend to Coffee Creek in Owasso, OK! Great friends make great neighbors. Join our vibrant community and enjoy the good life together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Coffee Creek",
  "property_seo_description_scheduletour": "Experience vibrant living at Coffee Creek in Owasso, OK. Schedule a tour today and see why our community feels like home sweet home. Your next chapter awaits!",
  "property_seo_title_privacy": "Privacy Policy | Coffee Creek",
  "property_seo_description_privacy": "At Coffee Creek in Owasso, OK, we value your privacy. Learn how we protect your information with our comprehensive privacy policy. Your peace of mind matters!",
  "property_seo_title_accessibility": "Website Accessibility | Coffee Creek",
  "property_seo_description_accessibility": "At Coffee Creek in Owasso, we prioritize accessibility for all. Experience a community built for everyone, where digital inclusion matters. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Coffee Creek",
  "property_seo_description_sitemap": "Explore Coffee Creek in Owasso, OK! Use our sitemap for easy access to amenities, floor plans, and all that our vibrant community offers.",
  "property_seo_title_thankyou": "Thank You | Coffee Creek",
  "property_seo_description_thankyou": "Thanks for reaching out to Coffee Creek in Owasso, OK! Our team will be in touch soon to help you discover your perfect home in our vibrant community!",
  "property_seo_title_pets": "Pet Policy | Apartments in Owasso, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865036852",
  "amenities": [
    {
      "id": "ec_244ac6b4ef66a7603f162d59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396402",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a0ed8cf692e3f9dbcc575d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396404",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06d8ce46d40d1ddf5c873133",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396405",
      "title": "24-Hour Fitness Center w/ Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2894279638210258e3239e76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396406",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9eb4edeb0f8c9a9e974113c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396407",
      "title": "Resident Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62dd78e6235c1fd7e57a768b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396408",
      "title": "Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63d6504cada9859617292b07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396409",
      "title": "Limited-Access Gates",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b5c4f083a69b21c3e776a30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396410",
      "title": "Executive Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fdfb89da37d82aec259f8261",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396411",
      "title": "Community Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_27219e4714e3087d84b166a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396412",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8568ccab21457ab79785b2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396413",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc44201235a5d9e4ec117fa7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396414",
      "title": "Professional Management Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c7ca488b106d48b5cf98644",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396415",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_648f9d015cf851bed8ac808a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127396416",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5510776b4ef3716dffad6b6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "128017301",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ed990e50f0f422f5dd581cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397897",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e233940d9105843d2b8869a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397898",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e93c37165adff8a6a9d4e933",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397899",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_862318b723e4e568cd159ce1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397900",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aee204ce9b6f941c095f11e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397901",
      "title": "Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65bfb2784d1651e1087afcf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397902",
      "title": "Large Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36d5eb70a24dde10fa9e0262",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397903",
      "title": "Patio or Sunroom",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1413039642b9c284467c7103",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397907",
      "title": "Gourmet Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b5b83a5cdcfa595db4e4b3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397908",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0bfb3a396544d6378dfccf86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397909",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f2ec8f55cf55d9373fc58ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397910",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b315b773d20a0f0b6847979",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397911",
      "title": "Abundant Living Area",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_66e634cf0913e2faa9cc5343",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397912",
      "title": "Ceramic Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc90814d41f62760b766d0f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "yardi",
      "external_id": "127397913",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_95bd2cfd-57af-4a91-8691-f5a8fd743cfa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3d-4c10-7256-914f-966cc3201be3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel microwave, and white stove.",
        "public_id": "019ddf3d-4c10-7256-914f-966cc3201be3",
        "storage_key": "property/6767906449167036/019ddf3d-4c10-7256-914f-966cc3201be3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "This apartment kitchen features dark wood cabinetry, granite countertops, a stainless steel microwave, and a white stove, offering a functional and stylish space for cooking.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel microwave, and white stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1aafa08a-4b8b-4a19-a712-7b015b3c211c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3d-4f40-72d4-a922-9bef483f427f.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019ddf3d-4f40-72d4-a922-9bef483f427f",
        "storage_key": "property/6767906449167036/019ddf3d-4f40-72d4-a922-9bef483f427f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a spacious vanity with ample counter space, a modern toilet, and a bathtub with a stylish shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e3da542-70ad-450e-90ae-fe9b716f3067",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3d-6c6e-72fe-b245-9ea6c8236a1d.webp",
      "image_media": {
        "alt_text": "Cozy living and dining area with plush sofa, accent chair, and dining table.",
        "public_id": "019ddf3d-6c6e-72fe-b245-9ea6c8236a1d",
        "storage_key": "property/6767906449167036/019ddf3d-6c6e-72fe-b245-9ea6c8236a1d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this inviting apartment featuring a spacious living area and a dedicated dining space, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Cozy living and dining area with plush sofa, accent chair, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c222b7cc-230e-4d6f-ac8e-f5f3d10ceec4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3d-4d62-7078-8f64-9059ebc4bab3.webp",
      "image_media": {
        "alt_text": "Empty closet with wire shelving and storage baskets",
        "public_id": "019ddf3d-4d62-7078-8f64-9059ebc4bab3",
        "storage_key": "property/6767906449167036/019ddf3d-4d62-7078-8f64-9059ebc4bab3.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty closet with wire shelving and storage baskets",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e99d32ef-abaa-4748-9d74-f93e37247cb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3d-7189-709b-9bfb-9a28d5ce6047.webp",
      "image_media": {
        "alt_text": "Dining room with a table and four chairs.",
        "public_id": "019ddf3d-7189-709b-9bfb-9a28d5ce6047",
        "storage_key": "property/6767906449167036/019ddf3d-7189-709b-9bfb-9a28d5ce6047.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A stylish dining room featuring a wooden table with upholstered chairs, perfect for family meals.",
      "link": "",
      "alt_text": "Dining room with a table and four chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_80901df4-6137-49cd-bcd5-fddc183e40f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3d-4d35-727e-a613-99e0daa33c00.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a queen-size bed, dresser, and nightstand.",
        "public_id": "019ddf3d-4d35-727e-a613-99e0daa33c00",
        "storage_key": "property/6767906449167036/019ddf3d-4d35-727e-a613-99e0daa33c00.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy comfort and style in this beautifully appointed bedroom, featuring a plush queen-size bed, elegant dresser, and a cozy nightstand.",
      "link": "",
      "alt_text": "Spacious bedroom with a queen-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a356970f-e2cc-4afe-affd-0e8703a1f04d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3d-67c6-723a-afe6-7e3916d66bc9.webp",
      "image_media": {
        "alt_text": "Cozy living and dining area with open kitchen and breakfast bar.",
        "public_id": "019ddf3d-67c6-723a-afe6-7e3916d66bc9",
        "storage_key": "property/6767906449167036/019ddf3d-67c6-723a-afe6-7e3916d66bc9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this open-concept apartment, featuring a modern kitchen, dining area, and a spacious living room perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Cozy living and dining area with open kitchen and breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_325734b1-a06e-43e9-9b9c-c804301f4598",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3d-6955-72e1-bb59-e5d5a599b794.webp",
      "image_media": {
        "alt_text": "Living room and kitchen of an apartment, featuring a sofa, coffee table, TV, and bar stools.",
        "public_id": "019ddf3d-6955-72e1-bb59-e5d5a599b794",
        "storage_key": "property/6767906449167036/019ddf3d-6955-72e1-bb59-e5d5a599b794.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly connected to a modern kitchen, perfect for entertaining. Enjoy a comfortable living room with a TV and a stylish kitchen with bar seating.",
      "link": "",
      "alt_text": "Living room and kitchen of an apartment, featuring a sofa, coffee table, TV, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8232825a-c93b-4cfa-b1cd-4695b85d0ca0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3d-6c6b-731b-8ec6-227328bbd65e.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with wood vanity, sink, toilet, and bathtub with shower curtain.",
        "public_id": "019ddf3d-6c6b-731b-8ec6-227328bbd65e",
        "storage_key": "property/6767906449167036/019ddf3d-6c6b-731b-8ec6-227328bbd65e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Renovated apartment bathroom featuring a wood vanity with granite countertop, a modern sink, a toilet, and a bathtub with a stylish shower curtain.",
      "link": "",
      "alt_text": "Modern apartment bathroom with wood vanity, sink, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7bd36bc0-8238-452e-861f-d5c7777a8746",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3d-4cf3-7361-b87e-8a63e36d6671.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, two nightstands with lamps, and a closet.",
        "public_id": "019ddf3d-4cf3-7361-b87e-8a63e36d6671",
        "storage_key": "property/6767906449167036/019ddf3d-4cf3-7361-b87e-8a63e36d6671.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, bedside tables with elegant lamps, and ample closet space for your storage needs.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, two nightstands with lamps, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b782b872-d0bf-4a0f-87c7-2fbf754313c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3d-4b82-708f-9562-9330b19da13e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a granite countertop.",
        "public_id": "019ddf3d-4b82-708f-9562-9330b19da13e",
        "storage_key": "property/6767906449167036/019ddf3d-4b82-708f-9562-9330b19da13e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious and modern kitchen, featuring dark wood cabinetry, granite countertops, and stainless steel appliances. Perfect for preparing meals and entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_242bf640-165c-452e-b83d-a172b5cffb5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3d-4c1b-7016-b3e1-1d83aade61ec.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019ddf3d-4c1b-7016-b3e1-1d83aade61ec",
        "storage_key": "property/6767906449167036/019ddf3d-4c1b-7016-b3e1-1d83aade61ec.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark wood cabinetry, a stainless steel microwave and oven, and granite-style countertops.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b9c2f9f7-023c-4c06-a715-afbefb05c5bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-f9fa-711c-a4bb-6799d7093c1d.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs, and a desk in the background.",
        "public_id": "019ddf3c-f9fa-711c-a4bb-6799d7093c1d",
        "storage_key": "property/6767906449167036/019ddf3c-f9fa-711c-a4bb-6799d7093c1d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals and work from home in this spacious dining and living area, featuring a comfortable dining set and a well-lit desk space.",
      "link": "",
      "alt_text": "Dining area with a table and chairs, and a desk in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_47e75a77-8d44-411e-a095-15de84f98dbc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-f614-7424-a2ec-e200bf9682cc.webp",
      "image_media": {
        "alt_text": "Open concept living and kitchen area with dining table, sofa, coffee table, and kitchen island with bar stools.",
        "public_id": "019ddf3c-f614-7424-a2ec-e200bf9682cc",
        "storage_key": "property/6767906449167036/019ddf3c-f614-7424-a2ec-e200bf9682cc.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with a breakfast bar, comfortable living room seating, and a dedicated dining space.",
      "link": "",
      "alt_text": "Open concept living and kitchen area with dining table, sofa, coffee table, and kitchen island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9c46cb63-e208-4832-974a-8383b5d2227f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-f960-714f-965d-47b4da54d436.webp",
      "image_media": {
        "alt_text": "Home office with a desk and chair",
        "public_id": "019ddf3c-f960-714f-965d-47b4da54d436",
        "storage_key": "property/6767906449167036/019ddf3c-f960-714f-965d-47b4da54d436.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Create your perfect workspace in this inviting home office, featuring a stylish desk and comfortable seating.",
      "link": "",
      "alt_text": "Home office with a desk and chair",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_493c254e-a61b-4f28-8da9-70c6fca8e0d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-d98b-76dd-b7ce-74df7121d780.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, bathtub, vanity with granite countertop, and mirror",
        "public_id": "019ddf3c-d98b-76dd-b7ce-74df7121d780",
        "storage_key": "property/6767906449167036/019ddf3c-d98b-76dd-b7ce-74df7121d780.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a toilet, bathtub with shower curtain, and a vanity with granite countertop and ample storage. Perfect for your daily routine.",
      "link": "",
      "alt_text": "Bathroom with toilet, bathtub, vanity with granite countertop, and mirror",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b6d58593-ab20-47a6-a04a-3d65f6ebe447",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-b8fd-7720-b39b-03404bb482b2.webp",
      "image_media": {
        "alt_text": "Stylish open-concept living and dining area with a large desk and artwork.",
        "public_id": "019ddf3c-b8fd-7720-b39b-03404bb482b2",
        "storage_key": "property/6767906449167036/019ddf3c-b8fd-7720-b39b-03404bb482b2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy spacious living in our beautifully appointed apartments, featuring a flexible open-concept design perfect for both work and dining.",
      "link": "",
      "alt_text": "Stylish open-concept living and dining area with a large desk and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f568759d-df89-4176-b4d7-fd0cd31c5606",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-e1f7-743d-953f-f8f02d26ed24.webp",
      "image_media": {
        "alt_text": "Living and dining area with a sectional sofa, accent chair, dining table, and desk.",
        "public_id": "019ddf3c-e1f7-743d-953f-f8f02d26ed24",
        "storage_key": "property/6767906449167036/019ddf3c-e1f7-743d-953f-f8f02d26ed24.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sectional sofa, a stylish accent chair, a dedicated workspace, and a elegant dining table, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living and dining area with a sectional sofa, accent chair, dining table, and desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b1bf84bb-faac-414c-adb6-577d8023c11f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-c71e-771a-9eb5-6899f91f1060.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, granite countertops, and a coffee maker.",
        "public_id": "019ddf3c-c71e-771a-9eb5-6899f91f1060",
        "storage_key": "property/6767906449167036/019ddf3c-c71e-771a-9eb5-6899f91f1060.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring dark wood cabinetry, granite countertops, a microwave, oven, dishwasher, and a coffee station. Perfect for home-cooked meals.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, granite countertops, and a coffee maker.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6687d8fe-b33b-4d72-b481-c0aea65aa3fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-cf7b-7342-98dc-11126f608d53.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a queen-size bed, pink linens, dresser, and nightstand.",
        "public_id": "019ddf3c-cf7b-7342-98dc-11126f608d53",
        "storage_key": "property/6767906449167036/019ddf3c-cf7b-7342-98dc-11126f608d53.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy primary bedroom featuring a comfortable queen-size bed, stylish dresser, and nightstand. Perfect for relaxation.",
      "link": "",
      "alt_text": "Primary bedroom with a queen-size bed, pink linens, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e5c69468-4dc3-4c34-8b12-3e9a912c4562",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-b910-7739-8c91-1e8d66c33fc9.webp",
      "image_media": {
        "alt_text": "Dining area with a round wooden table and four chairs, set by a large window with blinds.",
        "public_id": "019ddf3c-b910-7739-8c91-1e8d66c33fc9",
        "storage_key": "property/6767906449167036/019ddf3c-b910-7739-8c91-1e8d66c33fc9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, perfect for family gatherings or intimate dinners. The space features a comfortable round table and chairs, illuminated by natural light from the large windows.",
      "link": "",
      "alt_text": "Dining area with a round wooden table and four chairs, set by a large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2bfbc27f-771a-4321-9881-09df8345bfd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-a9ac-7683-839b-85dd7c3282e2.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with a sofa, coffee table, and breakfast bar.",
        "public_id": "019ddf3c-a9ac-7683-839b-85dd7c3282e2",
        "storage_key": "property/6767906449167036/019ddf3c-a9ac-7683-839b-85dd7c3282e2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring a comfortable sofa, modern coffee table, and a breakfast bar with stools. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment with a sofa, coffee table, and breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bebd21f9-c8a5-44b5-bcd9-341ed0a7752d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-8387-73cc-9197-0132ac3e4ef0.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, dresser, and nightstand.",
        "public_id": "019ddf3c-8387-73cc-9197-0132ac3e4ef0",
        "storage_key": "property/6767906449167036/019ddf3c-8387-73cc-9197-0132ac3e4ef0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this comfortable bedroom, featuring a plush queen-size bed, elegant dresser, and convenient nightstand.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_941aa694-4e4b-4bcf-9a54-cd709150dec3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-b10f-729d-adc0-b4f19f7cb4ba.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and dining area.",
        "public_id": "019ddf3c-b10f-729d-adc0-b4f19f7cb4ba",
        "storage_key": "property/6767906449167036/019ddf3c-b10f-729d-adc0-b4f19f7cb4ba.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable seating, and a dining area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec942ac1-e019-4f1c-b794-c4b6e6d5fad3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-63e8-709b-9a45-a3da551c604f.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, television, and decorative elements.",
        "public_id": "019ddf3c-63e8-709b-9a45-a3da551c604f",
        "storage_key": "property/6767906449167036/019ddf3c-63e8-709b-9a45-a3da551c604f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, mounted television, and comfortable seating. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace, television, and decorative elements.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2dab5500-7d7b-49d8-8fef-a7c580806894",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3c-5a8a-770d-9201-c33cf25c9a90.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, and TV.",
        "public_id": "019ddf3c-5a8a-770d-9201-c33cf25c9a90",
        "storage_key": "property/6767906449167036/019ddf3c-5a8a-770d-9201-c33cf25c9a90.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed living room featuring a comfortable sofa, plush armchair, and entertainment center.",
      "link": "",
      "alt_text": "Living room with sofa, armchair, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_62ddeb3e-a81c-47d6-bd50-ec60381d5973",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3b-d9f9-7598-8ec0-a42a1dbc6b51.webp",
      "image_media": {
        "alt_text": "Business center with computers and seating area",
        "public_id": "019ddf3b-d9f9-7598-8ec0-a42a1dbc6b51",
        "storage_key": "property/6767906449167036/019ddf3b-d9f9-7598-8ec0-a42a1dbc6b51.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay connected in our modern business center, equipped with computers and comfortable seating for your convenience.",
      "link": "",
      "alt_text": "Business center with computers and seating area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6640d09a-fc17-4771-a2c0-6ab131d6b869",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3b-d9ed-756f-b88f-52e3ff2af314.webp",
      "image_media": {
        "alt_text": "Treadmill, weight machines, free weights, and medicine balls in a fitness center.",
        "public_id": "019ddf3b-d9ed-756f-b88f-52e3ff2af314",
        "storage_key": "property/6767906449167036/019ddf3b-d9ed-756f-b88f-52e3ff2af314.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines, weightlifting equipment, and free weights.",
      "link": "",
      "alt_text": "Treadmill, weight machines, free weights, and medicine balls in a fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5eca8a48-9eeb-414f-b2ac-03656be5c970",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3b-da6e-73cb-bc66-f18d4d8f9b49.webp",
      "image_media": {
        "alt_text": "Community coffee bar with Keurig coffee maker, cups, and condiments.",
        "public_id": "019ddf3b-da6e-73cb-bc66-f18d4d8f9b49",
        "storage_key": "property/6767906449167036/019ddf3b-da6e-73cb-bc66-f18d4d8f9b49.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee at the community coffee bar, featuring a Keurig coffee maker, cups, and all the fixings for a perfect brew.",
      "link": "",
      "alt_text": "Community coffee bar with Keurig coffee maker, cups, and condiments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_102d7c45-223a-4c4f-8192-d3b652deb562",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3b-d9ef-74bc-8254-b31e4d53bd45.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, treadmills, and elliptical.",
        "public_id": "019ddf3b-d9ef-74bc-8254-b31e4d53bd45",
        "storage_key": "property/6767906449167036/019ddf3b-d9ef-74bc-8254-b31e4d53bd45.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a variety of cardio machines and weight training equipment.",
      "link": "",
      "alt_text": "Fitness center with weight machines, treadmills, and elliptical.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3c46049e-558d-4ad8-9ecd-1f0f3ccd0144",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3b-e064-7060-ac86-b65a15e7522f.webp",
      "image_media": {
        "alt_text": "Business center with a printer, phone, bulletin board, and TV.",
        "public_id": "019ddf3b-e064-7060-ac86-b65a15e7522f",
        "storage_key": "property/6767906449167036/019ddf3b-e064-7060-ac86-b65a15e7522f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Utilize the convenient business center, equipped with a printer, phone, and TV, to stay productive during your stay.",
      "link": "",
      "alt_text": "Business center with a printer, phone, bulletin board, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e212b388-14f7-45bc-bc36-5b23761eb5e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3b-361e-70e1-a89d-201ea0f78048.webp",
      "image_media": {
        "alt_text": "Luxurious swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019ddf3b-361e-70e1-a89d-201ea0f78048",
        "storage_key": "property/6767906449167036/019ddf3b-361e-70e1-a89d-201ea0f78048.webp",
        "width": 3072,
        "height": 2043
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by beautiful landscaping and comfortable seating. Perfect for relaxing on a sunny day.",
      "link": "",
      "alt_text": "Luxurious swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8c15f7c6-9629-48c4-b4d2-7d92c45533a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3b-4b80-75f4-9487-05fb2c57399b.webp",
      "image_media": {
        "alt_text": "View of the community pool and clubhouse from a balcony.",
        "public_id": "019ddf3b-4b80-75f4-9487-05fb2c57399b",
        "storage_key": "property/6767906449167036/019ddf3b-4b80-75f4-9487-05fb2c57399b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the community amenities, including a refreshing pool and clubhouse, right from your private balcony.",
      "link": "",
      "alt_text": "View of the community pool and clubhouse from a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_44b36bf6-7cc9-4e13-86b2-6b57427e9415",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3b-3aa2-75cc-9301-c2abeb9c9fd1.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with garages and parking lot",
        "public_id": "019ddf3b-3aa2-75cc-9301-c2abeb9c9fd1",
        "storage_key": "property/6767906449167036/019ddf3b-3aa2-75cc-9301-c2abeb9c9fd1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the apartment building exterior, showcasing the garages and a well-maintained parking lot with cars.",
      "link": "",
      "alt_text": "Apartment building exterior with garages and parking lot",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fbd05b0a-dd6c-4432-8825-3b8a4a87a813",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3b-405c-7313-a871-e82886ae6f87.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge area with surrounding apartment buildings.",
        "public_id": "019ddf3b-405c-7313-a871-e82886ae6f87",
        "storage_key": "property/6767906449167036/019ddf3b-405c-7313-a871-e82886ae6f87.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge seating. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool and lounge area with surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_af8ca710-c264-4554-b147-3a04bdc12072",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3a-f2cc-7096-93f6-112cf83a7009.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with brick and siding.",
        "public_id": "019ddf3a-f2cc-7096-93f6-112cf83a7009",
        "storage_key": "property/6767906449167036/019ddf3a-f2cc-7096-93f6-112cf83a7009.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfortable living in this apartment building's exterior. Enjoy the well-maintained grounds and classic architecture.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with brick and siding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ca09437b-1907-4ce1-ae62-49f82696c89f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3b-2f61-73d8-a2eb-d9646513e080.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019ddf3b-2f61-73d8-a2eb-d9646513e080",
        "storage_key": "property/6767906449167036/019ddf3b-2f61-73d8-a2eb-d9646513e080.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling resort-style swimming pool, surrounded by lush landscaping and comfortable lounge chairs. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b45558d3-e5cf-426e-9256-a1e1e7c1486f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3b-2bcd-7465-863e-1197a3a1a821.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and seating areas.",
        "public_id": "019ddf3b-2bcd-7465-863e-1197a3a1a821",
        "storage_key": "property/6767906449167036/019ddf3b-2bcd-7465-863e-1197a3a1a821.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable seating. Perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3cce8e91-d696-486f-9a60-22942174e8c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3b-24d0-70fe-8653-d6fc8bfcdefe.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and building in the background.",
        "public_id": "019ddf3b-24d0-70fe-8653-d6fc8bfcdefe",
        "storage_key": "property/6767906449167036/019ddf3b-24d0-70fe-8653-d6fc8bfcdefe.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a5244c3a-a62e-42bb-8589-b8c4f140a746",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3a-d2ae-73d9-92c7-fe8e60e7da97.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area, with apartment buildings in the background.",
        "public_id": "019ddf3a-d2ae-73d9-92c7-fe8e60e7da97",
        "storage_key": "property/6767906449167036/019ddf3a-d2ae-73d9-92c7-fe8e60e7da97.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge seating and a shaded cabana for relaxation. Perfect for sunny afternoons and unwinding after a long day.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_70c50d59-b4d9-429c-8aa8-2a3a88582243",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3a-d42f-76fc-b762-5b2e417ff600.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen and fireplace area with picnic tables and umbrellas.",
        "public_id": "019ddf3a-d42f-76fc-b762-5b2e417ff600",
        "storage_key": "property/6767906449167036/019ddf3a-d42f-76fc-b762-5b2e417ff600.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and cozy evenings in our outdoor kitchen and fireplace area. Perfect for gathering with friends and family.",
      "link": "",
      "alt_text": "Outdoor kitchen and fireplace area with picnic tables and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d754292d-59e1-4a9b-9545-69a712c3f8ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3a-d30c-71fd-b702-b5a023590b96.webp",
      "image_media": {
        "alt_text": "The Park at Coffee Creek building exterior with a tower and arched windows.",
        "public_id": "019ddf3a-d30c-71fd-b702-b5a023590b96",
        "storage_key": "property/6767906449167036/019ddf3a-d30c-71fd-b702-b5a023590b96.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The beautiful exterior of The Park at Coffee Creek community, featuring a distinctive tower and welcoming arched entryways.",
      "link": "",
      "alt_text": "The Park at Coffee Creek building exterior with a tower and arched windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_51a2602b-c1a1-4cd1-bd6e-82c3ae20922d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3a-d55f-704c-9fa3-122b280f9c01.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with picnic tables, umbrellas, grills, and a stone fireplace.",
        "public_id": "019ddf3a-d55f-704c-9fa3-122b280f9c01",
        "storage_key": "property/6767906449167036/019ddf3a-d55f-704c-9fa3-122b280f9c01.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with our community's picnic tables, grills, and cozy stone fireplace. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Outdoor seating area with picnic tables, umbrellas, grills, and a stone fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_09abbb1a-6f1a-4c60-8e0c-2ae7231b4cb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3a-d552-736e-a174-04c887757890.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including red horses, a blue platform, and a red tunnel.",
        "public_id": "019ddf3a-d552-736e-a174-04c887757890",
        "storage_key": "property/6767906449167036/019ddf3a-d552-736e-a174-04c887757890.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with fun agility equipment for your furry friends.",
      "link": "",
      "alt_text": "Dog park with agility equipment including red horses, a blue platform, and a red tunnel.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c653f7a3-e1f7-4e6d-bd87-b86a713accce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019ddf3a-f06f-732a-a5f2-381dc791e0cb.webp",
      "image_media": {
        "alt_text": "Canine Creek dog park with a bench and play equipment.",
        "public_id": "019ddf3a-f06f-732a-a5f2-381dc791e0cb",
        "storage_key": "property/6767906449167036/019ddf3a-f06f-732a-a5f2-381dc791e0cb.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy our off-leash dog park, designed for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Canine Creek dog park with a bench and play equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d6c039a1-43f9-47e8-a383-dd978b95a9df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "9311 N Owasso Expy, Owasso, OK 74055, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and rolls. They also highlight the good value, lively atmosphere, and friendly service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-d93f-777e-9e0f-0a99f98f8a35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-d93f-777e-9e0f-0a99f98f8a35",
        "storage_key": "property/6767906449167036/019cfb50-d93f-777e-9e0f-0a99f98f8a35.webp",
        "width": 560,
        "height": 315
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/owasso?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7489778363057715607&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.2890186",
      "poi_longitude": "-95.8379704",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-516-1075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b812-77a2-a8a3-9b47c7c8d084",
        "storage_key": "property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2cw0P4XxtocRlzl2GL0J8Wc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_dce2211c-42e3-40f6-8cba-c8c2e9cff39a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "MAD Eats",
      "poi_type": "Restaurants",
      "poi_address": "201 S Main St STE #130, Owasso, OK 74055, USA",
      "poi_short_description": "Casual eatery serving burgers, tacos, mac and cheese, sandwiches, breakfast items, meatloaf and shakes.",
      "poi_long_description": "People say this diner serves delicious burgers, shakes, and pies, and offers unique options like Chicken Fried Meatloaf and Taco Mac & Cheese. They also highlight the generous portions, fun atmosphere, and friendly service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-d8da-778f-9033-f1236f6278d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-d8da-778f-9033-f1236f6278d8",
        "storage_key": "property/6767906449167036/019cfb50-d8da-778f-9033-f1236f6278d8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.madeatsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1802710814106412544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mad-eats",
      "poi_latitude": "36.2635117",
      "poi_longitude": "-95.8542858",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-401-4353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b812-77a2-a8a3-9b47c7c8d084",
        "storage_key": "property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBZLFS_bwtocRAGaRK--DBBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_b6c35461-ce5e-46ee-8ddf-3f5de3345bf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "13301 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves hot, crispy, and flavorful chicken fingers, along with Texas toast and crinkle-cut fries. They highlight the fast and friendly service, and the clean and well-organized restaurant. They also like the kind and engaging staff and management.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-d8e3-71fc-9ab9-e43d0efc442c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-d8e3-71fc-9ab9-e43d0efc442c",
        "storage_key": "property/6767906449167036/019cfb50-d8e3-71fc-9ab9-e43d0efc442c.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/owasso/13301-e.-96th-st.-north",
      "poi_directions_map_url": "https://maps.google.com/?cid=11347752542593289881&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.2934128",
      "poi_longitude": "-95.826651",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-376-9426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b812-77a2-a8a3-9b47c7c8d084",
        "storage_key": "property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNwe5cajwtocRmQ5PhNBQe50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_9d20adb2-9449-40e2-8c5b-e1760a8dbf7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Restaurants",
      "poi_address": "11590 N 140th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-9c54-7149-a4a7-5f574f3a900d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-9c54-7149-a4a7-5f574f3a900d",
        "storage_key": "property/6767906449167036/019cfb50-9c54-7149-a4a7-5f574f3a900d.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ok/owasso/11590-n-140th-e-ave?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDM4MzEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1075741749885667753&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "36.32114",
      "poi_longitude": "-95.8192628",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-371-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b812-77a2-a8a3-9b47c7c8d084",
        "storage_key": "property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZXXJSH6tocRqQn-B2zN7Q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_ad5355b6-b79f-4dc0-bfb5-3f4c8c8d4fd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "12015 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches and meals. They also highlight the fast and friendly service, and the clean restaurant.\n\nSome reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-d8ba-73d1-a8e7-b8c09f1d0b60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-d8ba-73d1-a8e7-b8c09f1d0b60",
        "storage_key": "property/6767906449167036/019cfb50-d8ba-73d1-a8e7-b8c09f1d0b60.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/owasso-market?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=3068432268636994183&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.29352799999999",
      "poi_longitude": "-95.8402253",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-272-7201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b812-77a2-a8a3-9b47c7c8d084",
        "storage_key": "property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTTsZDJ7wtocRhzp0HeRClSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_c676e234-ba79-4e10-a8e2-de6b93d8aac3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9450 N 129th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide selection of products. They also highlight the helpful and friendly staff, and the clean and tidy store.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-9ca7-734c-8860-ac798cbb47e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-9ca7-734c-8860-ac798cbb47e7",
        "storage_key": "property/6767906449167036/019cfb50-9ca7-734c-8860-ac798cbb47e7.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Owasso/OK/Owasso/74055/8922?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1344320956374293089&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "36.2902973",
      "poi_longitude": "-95.8317215",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-376-9975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7fc-777b-a58b-7af39e9dc882",
        "storage_key": "property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP-C7bKHwtocRYZrNjMn8pxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_c451ed62-98dc-4992-8826-16c8fefc9172",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "12001 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products and services, including appliances, lumber, and assistance with home projects. They also highlight the friendly and helpful staff, as well as the clean and organized store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-9cb4-74fd-846f-3219f7016dcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-9cb4-74fd-846f-3219f7016dcd",
        "storage_key": "property/6767906449167036/019cfb50-9cb4-74fd-846f-3219f7016dcd.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Owasso/1500?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1500-_-na-_-0-_-0&y_source=1_MTE4NDM5Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10101766130383154022&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "36.29417",
      "poi_longitude": "-95.83639",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-274-0881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7fc-777b-a58b-7af39e9dc882",
        "storage_key": "property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJWmL4Z_wtocRZmuPLcauMIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_8ddc00f1-94e0-4128-87d6-3d0485bbc69e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9601 N 133rd E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, organic products, and sprouts. They highlight the good sales on health and vitamin products, and the convenient size of the store. They also like the friendly, knowledgeable, and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-d97d-772d-9f39-66043a215a01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-d97d-772d-9f39-66043a215a01",
        "storage_key": "property/6767906449167036/019cfb50-d97d-772d-9f39-66043a215a01.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://sprouts.com/store/ok/owasso/owasso",
      "poi_directions_map_url": "https://maps.google.com/?cid=6349055451709502037&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "36.294403",
      "poi_longitude": "-95.8260493",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-516-6656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b808-77ed-9f73-b5d9a1ed64bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b808-77ed-9f73-b5d9a1ed64bb",
        "storage_key": "property/6767906449167036/019cfb50-b808-77ed-9f73-b5d9a1ed64bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGbryiqfwtocRVfJmaktgHFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_33122aae-eddb-413d-82e4-66df918a803f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "9046 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-d8a4-70d2-9aac-92725c5d7a2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-d8a4-70d2-9aac-92725c5d7a2b",
        "storage_key": "property/6767906449167036/019cfb50-d8a4-70d2-9aac-92725c5d7a2b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7226706442748966127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "36.291631",
      "poi_longitude": "-95.8415924",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-272-3699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7fc-777b-a58b-7af39e9dc882",
        "storage_key": "property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAeOkQZzwtocR7zQUkDhrSmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_8267180a-45b7-4be7-87b6-5a54233a6057",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Reasor's",
      "poi_type": "Shopping & Retail",
      "poi_address": "11815 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Supermarket, bakery, and pharmacy chain offering a variety of goods including meat and produce.",
      "poi_long_description": "People say this grocery store offers amazing produce, a great bakery, and a wide variety of groceries and essentials. They also highlight the friendly and helpful staff, and the clean and well-laid-out store.\n\nSome reviews mention items can be out of stock.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb51-32cf-77b3-b620-48c37a5af09d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb51-32cf-77b3-b620-48c37a5af09d",
        "storage_key": "property/6767906449167036/019cfb51-32cf-77b3-b620-48c37a5af09d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.reasors.com/stores/owasso-south-86th",
      "poi_directions_map_url": "https://maps.google.com/?cid=9836905338792957670&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "reasors",
      "poi_latitude": "36.2798262",
      "poi_longitude": "-95.8425677",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-272-6211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b808-77ed-9f73-b5d9a1ed64bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b808-77ed-9f73-b5d9a1ed64bb",
        "storage_key": "property/6767906449167036/019cfb50-b808-77ed-9f73-b5d9a1ed64bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk3xRcJHwtocR5tbll0m1g4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b4e15352-db75-45f5-ac54-f5153c3b6742",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Owasso Library",
      "poi_type": "Education",
      "poi_address": "314 E 5th Ave Suite 202, Owasso, OK 74055, USA",
      "poi_short_description": "Community resource offering books and movies, plus educational programs and events.",
      "poi_long_description": "People say this public library has a wide selection of books, including vegetarian cookbooks, and offers a food drive that benefits the community. They also highlight the helpful and friendly staff who greet visitors and offer assistance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-d9c2-70bb-a21b-07873a3662b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-d9c2-70bb-a21b-07873a3662b9",
        "storage_key": "property/6767906449167036/019cfb50-d9c2-70bb-a21b-07873a3662b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tulsalibrary.org/owasso/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8627652818677722310&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "owasso-library",
      "poi_latitude": "36.2581947",
      "poi_longitude": "-95.8497147",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-5e4eb693de2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-5e4eb693de2a",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-5e4eb693de2a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnaj5dPbwtocRxuyu_oaUu3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_b606655a-01c1-4dbf-b822-206c649f8e41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Airtopia Adventure Park - Owasso",
      "poi_type": "Entertainment",
      "poi_address": "12932 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Multi-dimensional indoor amusement center offers trampolines, a warrior course, and more.",
      "poi_long_description": "People say this theme park offers a variety of fun activities, including trampolines, obstacle courses, and a virtual reality experience. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention some attractions can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-db8c-70b8-a5c2-9b2089cd6e44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-db8c-70b8-a5c2-9b2089cd6e44",
        "storage_key": "property/6767906449167036/019cfb50-db8c-70b8-a5c2-9b2089cd6e44.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.airtopiapark.com/owasso?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3729509317578422024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airtopia-adventure-park---owasso",
      "poi_latitude": "36.2766921",
      "poi_longitude": "-95.8278842",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-401-4650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-TfgZDxtocRCHfF7PbgwTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_15195e91-7f7c-432d-baf2-8b3d0eeb75f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Owasso Stadium",
      "poi_type": "Entertainment",
      "poi_address": "12901 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-dbdd-71db-883d-d635395fd7da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-dbdd-71db-883d-d635395fd7da",
        "storage_key": "property/6767906449167036/019cfb50-dbdd-71db-883d-d635395fd7da.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://stadiumconnection.com/ok/stadium.php?id=2455",
      "poi_directions_map_url": "https://maps.google.com/?cid=14776732685769457826&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "owasso-stadium",
      "poi_latitude": "36.2814643",
      "poi_longitude": "-95.8285307",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-eb93-70e8-b64e-ace3cd41a7f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-eb93-70e8-b64e-ace3cd41a7f7",
        "storage_key": "property/6767906449167036/019cfb50-eb93-70e8-b64e-ace3cd41a7f7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg5n_8kDxtocRokAxVBaAEc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_1273cdb9-11b4-45c6-a9d3-aa50cae01950",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Collinsville Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1901-1999 W Maple St, Collinsville, OK 74021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-db8c-70b8-a5c2-9c07731764e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-db8c-70b8-a5c2-9c07731764e9",
        "storage_key": "property/6767906449167036/019cfb50-db8c-70b8-a5c2-9c07731764e9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://stadiumconnection.com/ok/stadium.php?id=2529",
      "poi_directions_map_url": "https://maps.google.com/?cid=12965247704748893086&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "collinsville-stadium",
      "poi_latitude": "36.367661",
      "poi_longitude": "-95.8486856",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-eb93-70e8-b64e-ace3cd41a7f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-eb93-70e8-b64e-ace3cd41a7f7",
        "storage_key": "property/6767906449167036/019cfb50-eb93-70e8-b64e-ace3cd41a7f7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBdGdJ5v7tocRnqOBOhjQ7bM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_0317cc6f-d6a4-47f2-9e36-8534a75a3e44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Owasso Roundup",
      "poi_type": "Entertainment",
      "poi_address": "8120 N 91st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-ddde-7280-b786-d78b86a09641.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ddde-7280-b786-d78b86a09641",
        "storage_key": "property/6767906449167036/019cfb50-ddde-7280-b786-d78b86a09641.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10984323416409265704&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "owasso-roundup",
      "poi_latitude": "36.2728275",
      "poi_longitude": "-95.8742976",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-694-4513",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnz_3TFHxtocRKFYUJfMncJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_7ea02429-a968-414c-8195-fa068d9c72d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Owasso Museum",
      "poi_type": "Entertainment",
      "poi_address": "26 S Main St, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-de13-7708-9008-e37428f6eb2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-de13-7708-9008-e37428f6eb2f",
        "storage_key": "property/6767906449167036/019cfb50-de13-7708-9008-e37428f6eb2f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofowasso.com/283/Historical-Museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=6857264842603068093&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "owasso-museum",
      "poi_latitude": "36.2654952",
      "poi_longitude": "-95.8552377",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-272-4966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-bbc8-738c-ac26-174a182f56d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-bbc8-738c-ac26-174a182f56d8",
        "storage_key": "property/6767906449167036/019cfb50-bbc8-738c-ac26-174a182f56d8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQwKbfbwtocRvXohAgvmKV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_94487084-fdb0-44f8-8d50-eecd2c8f1ac6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "507 E 2nd Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Gym with the latest cardio and strength-training equipment, as well as classes and a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and amenities, including a sauna, tanning beds, and hydro massage chairs. They highlight the affordable prices, 24/7 access, and friendly, helpful staff. They also like the clean facilities and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-ddb2-7338-a81d-47b20de08942.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ddb2-7338-a81d-47b20de08942",
        "storage_key": "property/6767906449167036/019cfb50-ddb2-7338-a81d-47b20de08942.webp",
        "width": 825,
        "height": 462
      },
      "poi_business_url": "https://10gym.com/owasso-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8859217771743011312&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.2653089",
      "poi_longitude": "-95.8504279",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-609-6090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG85Rt3n3tocR8OGREKBD8no",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3b3e1ad5-7205-44b8-a6bc-49e131ccb143",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "SAHO Owasso Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12555 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-de23-7589-90bb-72f9a5034501.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-de23-7589-90bb-72f9a5034501",
        "storage_key": "property/6767906449167036/019cfb50-de23-7589-90bb-72f9a5034501.webp",
        "width": 1128,
        "height": 636
      },
      "poi_business_url": "https://sahovets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7283601458760437127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saho-owasso-animal-hospital",
      "poi_latitude": "36.2797463",
      "poi_longitude": "-95.8339312",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-274-8387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaZu1473wtocRh83uwu-MFGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_e1f21fc6-ca1d-40cd-a978-42268c99cadb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Barber Sports Lounge",
      "poi_type": "Health and Wellness",
      "poi_address": "11622 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Popular barbershop specializing in straight-razor shaves and detailed haircuts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-de34-7511-9d00-58c3dc82d8f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-de34-7511-9d00-58c3dc82d8f8",
        "storage_key": "property/6767906449167036/019cfb50-de34-7511-9d00-58c3dc82d8f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://placegem.top/barber-sports-lounge-cnilcpw",
      "poi_directions_map_url": "https://maps.google.com/?cid=11273226578980552883&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barber-sports-lounge",
      "poi_latitude": "36.277631",
      "poi_longitude": "-95.8451781",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-609-5069",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQYHk5HwtocRs8CgcNiLcpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_5f4204a0-eced-4bca-8d01-80d1de4e8273",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of Owasso",
      "poi_type": "Health and Wellness",
      "poi_address": "9045 N 121st E Ave Suite 1200, Owasso, OK 74055, USA",
      "poi_short_description": "Casual shop for men's and boys' haircuts as well as beard trimming and shaping. Also offers MVP treatments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-df12-746f-8a41-c28f39d7b8a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-df12-746f-8a41-c28f39d7b8a9",
        "storage_key": "property/6767906449167036/019cfb50-df12-746f-8a41-c28f39d7b8a9.webp",
        "width": 1279,
        "height": 720
      },
      "poi_business_url": "https://sportclips.com/us-ok-owasso-ok103?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=13715315186473060055&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-owasso",
      "poi_latitude": "36.2901849",
      "poi_longitude": "-95.8404563",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-274-7220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq4_3H5zwtocR10Y_yH6WVr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_5228281b-fef1-4e8b-a5f9-173384844bf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "9500 N 129th E Ave Ste 124, Owasso, OK 74055, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-deeb-7719-bd37-23b30e184099.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-deeb-7719-bd37-23b30e184099",
        "storage_key": "property/6767906449167036/019cfb50-deeb-7719-bd37-23b30e184099.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/ok/owasso/9500-n-129th-e-ave?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1714296183721100132&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "36.2912538",
      "poi_longitude": "-95.8310068",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-274-4561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQ4Yy6DwtocRZAOB3ktnyhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_0e71c60b-7f57-4c86-b969-745f1e59adb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Floyd's 99 Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "11340 E 96th St N Ste 400, Owasso, OK 74055, USA",
      "poi_short_description": "Chain barber shop offering haircuts, shaves, and shoulder massages, plus grooming products.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-e019-76ca-a803-03c8c71cf077.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e019-76ca-a803-03c8c71cf077",
        "storage_key": "property/6767906449167036/019cfb50-e019-76ca-a803-03c8c71cf077.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.floydsbarbershop.com/locations/oklahoma/tulsa/owasso",
      "poi_directions_map_url": "https://maps.google.com/?cid=13890106331849848605&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "floyds-99-barbershop",
      "poi_latitude": "36.292582",
      "poi_longitude": "-95.8459996",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-973-4610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO8ASMSbxtocRHXdQqh2Sw8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_7b5fa635-90a9-4a72-906c-d90c65692d1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Airbenders",
      "poi_type": "Health and Wellness",
      "poi_address": "9395 N Owasso Expy, Owasso, OK 74055, USA",
      "poi_short_description": "Well-maintained facility offering classes, birthday parties and special events such as Parents Night Out.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-e14d-763b-addf-8552e887a62d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e14d-763b-addf-8552e887a62d",
        "storage_key": "property/6767906449167036/019cfb50-e14d-763b-addf-8552e887a62d.webp",
        "width": 960,
        "height": 588
      },
      "poi_business_url": "http://airbendersgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11097384753689398637&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airbenders",
      "poi_latitude": "36.2877573",
      "poi_longitude": "-95.8384187",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-928-4288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTeSEalLxtocRbQ1-E6PUAZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8dac29c5-080b-41b0-b69f-e372881a9875",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "M Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "9540 N Garnett Rd Suite #114, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-e19a-77f5-8b4b-058b1ac5aee3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e19a-77f5-8b4b-058b1ac5aee3",
        "storage_key": "property/6767906449167036/019cfb50-e19a-77f5-8b4b-058b1ac5aee3.webp",
        "width": 1280,
        "height": 474
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12922025453757066769&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "m-nails",
      "poi_latitude": "36.2924919",
      "poi_longitude": "-95.8497314",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-274-7384",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwa-6fnvxtocREe6-ta9BVLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_81bc5d10-f259-4338-a4c4-5ddbc76da68d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Vintage Barbershop Co.",
      "poi_type": "Health and Wellness",
      "poi_address": "421 E 2nd Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Relaxed salon offering an array of services including haircuts, hot towel shaves and beard trims.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-e225-712f-b0a5-691875c1112a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e225-712f-b0a5-691875c1112a",
        "storage_key": "property/6767906449167036/019cfb50-e225-712f-b0a5-691875c1112a.webp",
        "width": 1206,
        "height": 1191
      },
      "poi_business_url": "http://www.vintagebarbershopcompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8470976327735755158&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vintage-barbershop-co",
      "poi_latitude": "36.2648651",
      "poi_longitude": "-95.8520044",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-998-6919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfcc8BAvxtocRlsFuwxb0jnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_99d5ebe4-fb7d-4dd0-8d79-43e44bcfa1de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "LUSH Nails & Spa OWASSO",
      "poi_type": "Health and Wellness",
      "poi_address": "11560 N 135th E Ave Unit 105, Owasso, OK 74055, USA",
      "poi_short_description": "Clean salon for manicures and pedicures, plus acrylic options and waxing services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-e235-7754-a76f-c982098cfe7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e235-7754-a76f-c982098cfe7f",
        "storage_key": "property/6767906449167036/019cfb50-e235-7754-a76f-c982098cfe7f.webp",
        "width": 608,
        "height": 341
      },
      "poi_business_url": "https://lushnailsandspaowasso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3743164198816847017&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lush-nails--spa-owasso",
      "poi_latitude": "36.3204521",
      "poi_longitude": "-95.825409",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-371-3952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ_-V94X7tocRqRRwtgFk8jM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_e3a27a5e-d529-4c3e-8233-aa5a5f25c2cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Ascension St. John Owasso",
      "poi_type": "Health and Wellness",
      "poi_address": "12451 E 100th St N, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-a610-7303-8f09-b46160c1f43b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a610-7303-8f09-b46160c1f43b",
        "storage_key": "property/6767906449167036/019cfb50-a610-7303-8f09-b46160c1f43b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/oklahoma/oktul/owasso-ascension-st-john-owasso?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4519634255069400250&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-st-john-owasso",
      "poi_latitude": "36.2992565",
      "poi_longitude": "-95.8353676",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-274-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-bb56-76c9-85be-9eeec1dfd42d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-bb56-76c9-85be-9eeec1dfd42d",
        "storage_key": "property/6767906449167036/019cfb50-bb56-76c9-85be-9eeec1dfd42d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJtX2-TAv6tocRukwZsGj3uD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fb006b06-04bb-4ed4-813d-015d65d271e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Warren Clinic Urgent Care - Owasso",
      "poi_type": "Health and Wellness",
      "poi_address": "11610 N 137th E Ave, Collinsville, OK 74021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-e2bd-7109-b25d-a2874f7d5224.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e2bd-7109-b25d-a2874f7d5224",
        "storage_key": "property/6767906449167036/019cfb50-e2bd-7109-b25d-a2874f7d5224.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/warren-clinic-urgent-care-owasso",
      "poi_directions_map_url": "https://maps.google.com/?cid=2973186174730484356&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "warren-clinic-urgent-care---owasso",
      "poi_latitude": "36.3231905",
      "poi_longitude": "-95.8194792",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-928-4180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-bb56-76c9-85be-9eeec1dfd42d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-bb56-76c9-85be-9eeec1dfd42d",
        "storage_key": "property/6767906449167036/019cfb50-bb56-76c9-85be-9eeec1dfd42d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJN5pJ53v7tocRhLrpwxLhQik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_98cb8f50-0365-4e12-8808-0fbb735ee7d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "The Patriot Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5790 N Patriot Dr, Owasso, OK 74055, USA",
      "poi_short_description": "Relaxed, welcoming golf club boasting scenic views and featuring an eatery.",
      "poi_long_description": "People say this golf course offers a challenging and beautiful course with amazing views and elevation changes. They highlight the friendly and welcoming atmosphere, and the spacious and well-maintained facilities, including a nice clubhouse and bar area. They also like the friendly staff and members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-e2ce-76cc-afe9-ea4db19ace8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e2ce-76cc-afe9-ea4db19ace8f",
        "storage_key": "property/6767906449167036/019cfb50-e2ce-76cc-afe9-ea4db19ace8f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.patriotgolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13926276483344965530&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-patriot-golf-club",
      "poi_latitude": "36.2386179",
      "poi_longitude": "-95.7725533",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-272-1260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-eb93-70e8-b64e-a8c4ba739ec9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-eb93-70e8-b64e-a8c4ba739ec9",
        "storage_key": "property/6767906449167036/019cfb50-eb93-70e8-b64e-a8c4ba739ec9.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJd2fvcfH2tocRmh-nUa0SRME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_615e6e1b-e157-4e8a-af94-9be20499d72d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Bailey Ranch Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10105 Larkin Bailey Blvd, Owasso, OK 74055, USA",
      "poi_short_description": "Public golf venue featuring greens and fairways along with a pro shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-e351-724e-b0f4-c9ee0789c522.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e351-724e-b0f4-c9ee0789c522",
        "storage_key": "property/6767906449167036/019cfb50-e351-724e-b0f4-c9ee0789c522.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.baileyranchgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16134891853489105549&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bailey-ranch-golf-course",
      "poi_latitude": "36.2837033",
      "poi_longitude": "-95.8633842",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-274-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-eb93-70e8-b64e-a8c4ba739ec9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-eb93-70e8-b64e-a8c4ba739ec9",
        "storage_key": "property/6767906449167036/019cfb50-eb93-70e8-b64e-a8c4ba739ec9.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJycM7dnzwtocRjeqPiKem6t8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_7c1457ba-3d20-4190-86fb-ff996ebf6786",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Funtastic Island",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10320 E 116th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Park featuring both a playground and a splash area equipped with a bucket feature.",
      "poi_long_description": "Visitors say this park has a fun splash pad with a large water bucket that dumps water on people, and a playground with lots of shade and plenty for kids of all ages to do. They also highlight that the park is clean, modern, safe, and family-friendly, with plenty of seating areas for parents.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-ad95-70f1-99d8-45db009be54c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ad95-70f1-99d8-45db009be54c",
        "storage_key": "property/6767906449167036/019cfb50-ad95-70f1-99d8-45db009be54c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofowasso.com/Facilities/Facility/Details/Funtastic-Island-6",
      "poi_directions_map_url": "https://maps.google.com/?cid=618726252255915832&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "funtastic-island",
      "poi_latitude": "36.3212018",
      "poi_longitude": "-95.859361",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-376-1529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7f9-700e-b92e-33792f4d99bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7f9-700e-b92e-33792f4d99bb",
        "storage_key": "property/6767906449167036/019cfb50-b7f9-700e-b92e-33792f4d99bb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRZTf9_b6tocROC_sjj8olgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3cc0caf4-eb87-4cfa-8d57-3c37682afe8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Centennial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15301 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Family-friendly destination boasting a playground, disc golf and ponds.",
      "poi_long_description": "Visitors say this park offers a challenging disc golf course, a walking trail, and a pond with scenic views. They also highlight the abundance of wildlife, including ducks, geese, squirrels, and beavers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-ac22-7219-9c02-5618aabc24ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ac22-7219-9c02-5618aabc24ec",
        "storage_key": "property/6767906449167036/019cfb50-ac22-7219-9c02-5618aabc24ec.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.cityofowasso.com/152/Recreation-and-Culture",
      "poi_directions_map_url": "https://maps.google.com/?cid=2374206344880589576&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "centennial-park",
      "poi_latitude": "36.2788037",
      "poi_longitude": "-95.8031131",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-376-1516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7f9-700e-b92e-33792f4d99bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7f9-700e-b92e-33792f4d99bb",
        "storage_key": "property/6767906449167036/019cfb50-b7f9-700e-b92e-33792f4d99bb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJaZaMFkb3tocRCAsWchfg8iA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_51d0a21a-2db2-451a-a5a1-9d03dfcb41b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Rayola Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8300 N Owasso Expy, Owasso, OK 74055, USA",
      "poi_short_description": "Green space with picnic shelters, a walking path & basketball court, plus a playground & splash pad.",
      "poi_long_description": "People say this park offers a large playground, a splash pad, pickleball courts, and a walking trail. They highlight the peaceful and safe atmosphere, and the well-maintained facilities. They also like the ample green space and shaded picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-ac22-7219-9c02-51218bf4f9e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ac22-7219-9c02-51218bf4f9e5",
        "storage_key": "property/6767906449167036/019cfb50-ac22-7219-9c02-51218bf4f9e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofowasso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5046342745985045140&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rayola-park",
      "poi_latitude": "36.2713222",
      "poi_longitude": "-95.84879920000002",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-376-1516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7f9-700e-b92e-33792f4d99bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7f9-700e-b92e-33792f4d99bb",
        "storage_key": "property/6767906449167036/019cfb50-b7f9-700e-b92e-33792f4d99bb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDZoluY_wtocRlNJOpf01CEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b495a996-3dd3-48e2-addc-5000386eadac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Gundys",
      "poi_type": "Transportation & Transit",
      "poi_address": "7806 N 172nd E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b099-755d-a12e-e94c60a43b10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-b099-755d-a12e-e94c60a43b10",
        "storage_key": "property/6767906449167036/019cfb50-b099-755d-a12e-e94c60a43b10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.gundysairport.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4107118366967304947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gundys",
      "poi_latitude": "36.2670849",
      "poi_longitude": "-95.7841404",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-272-1523",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-bbed-75ea-a626-88799f549ae4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-bbed-75ea-a626-88799f549ae4",
        "storage_key": "property/6767906449167036/019cfb50-bbed-75ea-a626-88799f549ae4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJhRmOtxH3tocR85KR8WRq_zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_a0598415-27e7-4a9d-ad3d-c3043570cd37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Airman Acres Airport-OK93",
      "poi_type": "Transportation & Transit",
      "poi_address": "E 126th St N, Collinsville, OK 74021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-e5c0-715e-aea2-cd3298c4d286.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e5c0-715e-aea2-cd3298c4d286",
        "storage_key": "property/6767906449167036/019cfb50-e5c0-715e-aea2-cd3298c4d286.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14842558028454321639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "airman-acres-airport-ok93",
      "poi_latitude": "36.3351884",
      "poi_longitude": "-95.8927046",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-371-2014",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-bbed-75ea-a626-88799f549ae4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-bbed-75ea-a626-88799f549ae4",
        "storage_key": "property/6767906449167036/019cfb50-bbed-75ea-a626-88799f549ae4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJqyvsHZ35tocR510kPONb-80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_9f8822d0-e46d-4fab-a7bd-9efdccda3e90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "City of Owasso",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 S Main St, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b1f0-720a-b161-8c090c2fdf1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-b1f0-720a-b161-8c090c2fdf1c",
        "storage_key": "property/6767906449167036/019cfb50-b1f0-720a-b161-8c090c2fdf1c.webp",
        "width": 601,
        "height": 290
      },
      "poi_business_url": "https://www.cityofowasso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16667434515310460285&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-owasso",
      "poi_latitude": "36.2637562",
      "poi_longitude": "-95.8555663",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-376-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-bc3a-7338-be33-353ac09af3f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-bc3a-7338-be33-353ac09af3f4",
        "storage_key": "property/6767906449167036/019cfb50-bc3a-7338-be33-353ac09af3f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydO3w_XwtocRfT0qQmKfTuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_54068b00-7735-4add-9b2c-6d4fae329600",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Legacy Living",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12150 E 96th St N Suite 200, Owasso, OK 74055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-e67e-71ae-ae6c-04a10419c53d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-e67e-71ae-ae6c-04a10419c53d",
        "storage_key": "property/6767906449167036/019cfb50-e67e-71ae-ae6c-04a10419c53d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.legacysl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17704443287973334600&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legacy-living",
      "poi_latitude": "36.2914006",
      "poi_longitude": "-95.8382875",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-376-6770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwQR0-J7wtocRSA6zRV7RsvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2e080ed6-6ba5-4d55-9db5-891fa96fa0a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Northeast Elementary",
      "poi_type": "Education",
      "poi_address": "13650 East 103rd St N, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://northeast.owassops.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12376512762987088512&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northeast-elementary",
      "poi_latitude": "36.30094700000001",
      "poi_longitude": "-95.8203936",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-272-0015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-5e4eb693de2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-5e4eb693de2a",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-5e4eb693de2a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJydiJaQL6tocRgArvy8g0wqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_4d58bab8-1f40-47c7-ab0e-b359d6729fb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Rejoice Christian School",
      "poi_type": "Education",
      "poi_address": "13407 E 106th St N, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-2575-762a-896f-14c316b3a2e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2575-762a-896f-14c316b3a2e3",
        "storage_key": "property/6767906449167036/019d7917-2575-762a-896f-14c316b3a2e3.webp",
        "width": 1280,
        "height": 460
      },
      "poi_business_url": "http://www.rejoiceschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12487743676581848759&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rejoice-christian-school",
      "poi_latitude": "36.3107571",
      "poi_longitude": "-95.825138",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-516-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-5e4eb693de2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-5e4eb693de2a",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-5e4eb693de2a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN-OPPBH6tocRt6bKALZgTa0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5a89c717-ec68-49e0-9fd5-e9e104666589",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Owasso Preparatory Academy",
      "poi_type": "Education",
      "poi_address": "9341 N 129th E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://owassoprep.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17717246513680442630&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "owasso-preparatory-academy",
      "poi_latitude": "36.2910614",
      "poi_longitude": "-95.829034",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-378-0344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-5e4eb693de2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-5e4eb693de2a",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-5e4eb693de2a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvXr7DqP7tocRBmXzjdVN4PU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_af6c3279-e6d4-4b6b-93e0-efb8b349fb97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Owasso High School Track",
      "poi_type": "Education",
      "poi_address": "12901 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-2594-7396-b0c6-211855d962de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2594-7396-b0c6-211855d962de",
        "storage_key": "property/6767906449167036/019d7917-2594-7396-b0c6-211855d962de.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18359467082622835272&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "owasso-high-school-track",
      "poi_latitude": "36.2812035",
      "poi_longitude": "-95.826348",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-272-1867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-5e4eb693de2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-5e4eb693de2a",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-5e4eb693de2a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU9Lqw7vwtocRSBo2_Qnuyf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_d1196503-d184-463e-a266-8a0b59466be2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "The University of Tulsa, North Campus",
      "poi_type": "Education",
      "poi_address": "2450 E Marshall St, Tulsa, OK 74110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5685378246054826000&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa-north-campus",
      "poi_latitude": "36.1711869",
      "poi_longitude": "-95.9551735",
      "poi_miles_from_property": "15.7 mi",
      "poi_walking_minutes": "5 hours 45 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-5e4eb693de2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-5e4eb693de2a",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-5e4eb693de2a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj6IE8kTstocRENDUcWSF5k4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c42e44af-0e46-4c47-ad90-6b7c8b12d61c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Red Robin Gourmet Burgers and Brews",
      "poi_type": "Restaurants",
      "poi_address": "9017 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_long_description": "Diners say this restaurant serves delicious burgers, especially the tavern set, jalapeño heat wave burger, and blue cheese crumble burger, with bottomless steak fries. They also highlight the friendly and attentive service, and the tasty campfire sauce.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-9824-762f-b8d3-ce587c530a52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-9824-762f-b8d3-ce587c530a52",
        "storage_key": "property/6767906449167036/019cfb50-9824-762f-b8d3-ce587c530a52.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.redrobin.com/locations/ok/owasso/owasso-444",
      "poi_directions_map_url": "https://maps.google.com/?cid=13263201928979773951&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-robin-gourmet-burgers-and-brews",
      "poi_latitude": "36.2867073",
      "poi_longitude": "-95.844652",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-376-9094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b812-77a2-a8a3-9b47c7c8d084",
        "storage_key": "property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpc8-R5vwtocR_3kdCeJbELg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_babbfb08-2d23-4fbf-8f69-58ee6c5e7c39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "13506 E 116th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "People say this coffee shop offers a variety of drinks, including caramel macchiatos and protein coffees. They also highlight the quick service and convenient location.\n\nSome reviews mention the staff can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-270c-76df-a0b6-e70c178edd48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-270c-76df-a0b6-e70c178edd48",
        "storage_key": "property/6767906449167036/019d7917-270c-76df-a0b6-e70c178edd48.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/1015013",
      "poi_directions_map_url": "https://maps.google.com/?cid=1995106842357331112&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "36.32154",
      "poi_longitude": "-95.82304",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-861-1491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b812-77a2-a8a3-95a39f560976.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b812-77a2-a8a3-95a39f560976",
        "storage_key": "property/6767906449167036/019cfb50-b812-77a2-a8a3-95a39f560976.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJhSXJZCP6tocRqPSoQxoLsBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_873718e4-4be1-4df4-88af-97e3201bdac8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Baja Jack's Burrito Shack",
      "poi_type": "Restaurants",
      "poi_address": "9045 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Casual, kid-friendly Mexican restaurant serving up tacos, burritos & beer in a festive setting.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, burritos, and quesadillas, and offers a fresh salsa bar with a variety of options. They highlight the generous portions, affordable prices, and the build-your-own burrito option. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-2b5f-717a-836c-37da6cde32db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2b5f-717a-836c-37da6cde32db",
        "storage_key": "property/6767906449167036/019d7917-2b5f-717a-836c-37da6cde32db.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://bajajacksonline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17114742089379239786&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "baja-jack-s-burrito-shack",
      "poi_latitude": "36.289514",
      "poi_longitude": "-95.840748",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-274-9940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b812-77a2-a8a3-9b47c7c8d084",
        "storage_key": "property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBalsEJzwtocRalfgo0DHg-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_eb824296-5e01-4a29-b280-276cf2314dab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "9072 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Diners say this Italian restaurant serves delicious breadsticks, salad, and Alfredo sauce, and they praise the unlimited soup, salad, and breadsticks. They also highlight the friendly and attentive service, and the peaceful atmosphere.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-2fc6-775d-946b-77306377ae70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2fc6-775d-946b-77306377ae70",
        "storage_key": "property/6767906449167036/019d7917-2fc6-775d-946b-77306377ae70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ok/owasso/owasso/1778?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:owasso-ok-1778_pl:locurl_rd:1625",
      "poi_directions_map_url": "https://maps.google.com/?cid=10788694414358487658&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "36.292518",
      "poi_longitude": "-95.839812",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-272-1436",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b812-77a2-a8a3-9b47c7c8d084",
        "storage_key": "property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJExXEOpzwtocRaiIUrmgkuZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_5ee90045-9b59-4bae-9b86-372e8cc1fd5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "12301 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "Diners say this restaurant is a great place to watch a game while enjoying the bar area, and they praise the friendly and attentive staff. They also highlight the inviting and modern yet cozy vibe of the restaurant.\n\nSome reviews mention the food can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-9822-76cb-afe2-71bcf2b4a7ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-9822-76cb-afe2-71bcf2b4a7ef",
        "storage_key": "property/6767906449167036/019cfb50-9822-76cb-afe2-71bcf2b4a7ef.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.chilis.com/locations/us/oklahoma/owasso/owasso?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=5652973548404604615&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chili-s-grill-bar",
      "poi_latitude": "36.293786",
      "poi_longitude": "-95.835895",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-274-3658",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b812-77a2-a8a3-9b47c7c8d084",
        "storage_key": "property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm4TdOZ7wtocRx_5V1X1lc04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_354047ad-1267-4b63-a089-9d618e6fc7cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Bull In The Alley",
      "poi_type": "Restaurants",
      "poi_address": "11 E Reconciliation Wy, Tulsa, OK 74103, USA",
      "poi_short_description": "Cosmopolitan chophouse & tavern turning out elevated American fare in smart surroundings.",
      "poi_long_description": "People say this restaurant serves delicious steaks, seafood, and sides, and offers a great selection of drinks. They highlight the generous portions, the speakeasy atmosphere, and the attentive service. They also like the live music and the attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-36f5-746e-8855-244d923d1fb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-36f5-746e-8855-244d923d1fb5",
        "storage_key": "property/6767906449167036/019d7917-36f5-746e-8855-244d923d1fb5.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.bullinthealley.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9411765724613022199&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bull-in-the-alley",
      "poi_latitude": "36.1588421",
      "poi_longitude": "-95.993318",
      "poi_miles_from_property": "18.1 mi",
      "poi_walking_minutes": "6 hours 36 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-949-9803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b812-77a2-a8a3-9b47c7c8d084",
        "storage_key": "property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOabdz4LrtocR95HBlA9PnYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_62c3fbf9-38f7-4810-83ea-75a8aaebcf8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Fleming’s Prime Steakhouse & Wine Bar",
      "poi_type": "Restaurants",
      "poi_address": "1976 Utica Square, Tulsa, OK 74114, USA",
      "poi_short_description": "High-end steakhouse chain with aged prime beef & classics such as lobster tails.",
      "poi_long_description": "People say this fine dining restaurant serves amazing steaks, including the Tomahawk and dry-aged ribeye, as well as delicious sides like corn and potatoes. They highlight the attentive service, with staff addressing guests by name and providing knowledgeable recommendations, and the special touches for celebrations, such as framed photos and complimentary champagne. They also like the renovated interior and fantastic decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-33d4-703c-bbb4-241a0dda0714.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-33d4-703c-bbb4-241a0dda0714",
        "storage_key": "property/6767906449167036/019d7917-33d4-703c-bbb4-241a0dda0714.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.flemingssteakhouse.com/Locations/OK/Tulsa?y_source=1_MTU1MDMxNTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7931387609107683437&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fleming-s-prime-steakhouse-wine-bar",
      "poi_latitude": "36.1313868",
      "poi_longitude": "-95.9640867",
      "poi_miles_from_property": "18.6 mi",
      "poi_walking_minutes": "6 hours 49 mins",
      "poi_biking_minutes": "1 hour 41 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 918-712-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b812-77a2-a8a3-9b47c7c8d084",
        "storage_key": "property/6767906449167036/019cfb50-b812-77a2-a8a3-9b47c7c8d084.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgdkD2b7stocRbVjMGALzEW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_fad06d7b-7379-4276-a595-a2f7dd1ac2e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "9010 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide selection of products. They also highlight the helpful and friendly staff.\n\nSome reviews mention the store can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-9cc3-729a-8e0f-3c631a34e6f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-9cc3-729a-8e0f-3c631a34e6f3",
        "storage_key": "property/6767906449167036/019cfb50-9cc3-729a-8e0f-3c631a34e6f3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/owasso/2095",
      "poi_directions_map_url": "https://maps.google.com/?cid=15682582055552125240&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.2895032",
      "poi_longitude": "-95.8446908",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-401-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7fc-777b-a58b-7af39e9dc882",
        "storage_key": "property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhdk_kJzwtocROIkZJkq5o9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_6ef2e09d-d377-4974-af56-17f77b8d9763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "12405 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "People say this department store offers a wide array of merchandise, including clothing and shoes. They also highlight the great sales and bargains, and the clean and well-organized store.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-3af9-760d-a0e9-d417764e3bcb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3af9-760d-a0e9-d417764e3bcb",
        "storage_key": "property/6767906449167036/019d7917-3af9-760d-a0e9-d417764e3bcb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/owasso-427.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13183147130991216566&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "36.2951942",
      "poi_longitude": "-95.8345596",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-376-2868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7fc-777b-a58b-7af39e9dc882",
        "storage_key": "property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJO148yZ_wtocRtgdx5Hfy87Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_0ffafca2-a0de-4c60-8663-350bbf8d7cc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "12101 E 96th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Department store offering a wide range of products, including groceries, apparel, electronics, and home goods.",
      "poi_long_description": "Some shoppers say this department store is well-stocked with a variety of products, including name brands, and has friendly and helpful staff.\n\nOther reviews mention the parking lot can be difficult to navigate and curbside pickup can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-46d6-7642-9313-edd9b6d8d0a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-46d6-7642-9313-edd9b6d8d0a8",
        "storage_key": "property/6767906449167036/019d7917-46d6-7642-9313-edd9b6d8d0a8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/168-owasso-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1134446284683515883&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "36.2949676",
      "poi_longitude": "-95.8378295",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-272-6609",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7fc-777b-a58b-7af39e9dc882",
        "storage_key": "property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF4ZOgnX6tocR65dSp-Jcvg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_4ec11d0b-b650-4256-a739-6a06214340fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Urban Okie Boutique",
      "poi_type": "Shopping & Retail",
      "poi_address": "129 S Main St, Owasso, OK 74055, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-4890-72fa-8106-9c5b92d2a129.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4890-72fa-8106-9c5b92d2a129",
        "storage_key": "property/6767906449167036/019d7917-4890-72fa-8106-9c5b92d2a129.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://urban-owasso-boutique.myshopify.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6856795824728269612&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "urban-okie-boutique",
      "poi_latitude": "36.264205",
      "poi_longitude": "-95.854792",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-863-5557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7fc-777b-a58b-7af39e9dc882",
        "storage_key": "property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFfHhRfbwtocRLGNPRnk7KF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_e8fa1535-e2a3-4577-8da3-dc75f89c6584",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Surcee Gifts & Home",
      "poi_type": "Shopping & Retail",
      "poi_address": "9455 N Owasso Expy # CB, Owasso, OK 74055, USA",
      "poi_short_description": "Gift shop at Tyann Plaza offering unique items for babies, kids, men, and the home.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-4a4f-712f-b505-79ec31fde249.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4a4f-712f-b505-79ec31fde249",
        "storage_key": "property/6767906449167036/019d7917-4a4f-712f-b505-79ec31fde249.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://surceegifts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15801257864321074778&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "surcee-gifts-home",
      "poi_latitude": "36.2895261",
      "poi_longitude": "-95.8364285",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-272-4005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7fc-777b-a58b-7af39e9dc882",
        "storage_key": "property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJ27iQp_wtocRWoY0F09YSds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_78dbd671-88e0-4167-b8a1-36acdcf75406",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "9055 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Shoppers say this electronics store offers a wide variety of appliances and devices, and they appreciate the friendly and helpful staff. They also highlight the clean and well-organized atmosphere, making for a pleasant shopping experience.\n\nSome reviews mention the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-4b0f-754e-8c2c-a15a11c92e91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4b0f-754e-8c2c-a15a11c92e91",
        "storage_key": "property/6767906449167036/019d7917-4b0f-754e-8c2c-a15a11c92e91.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/ok/owasso/9055-n-121st-east-ave-1401.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=8233666454085467095&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "36.290519",
      "poi_longitude": "-95.839714",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-272-5119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7fc-777b-a58b-7af39e9dc882",
        "storage_key": "property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK97ijZ7wtocR13vQIgTcQ3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_422d3c07-f06b-4a4e-96a8-a83811501177",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "T.J. Maxx & HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "9018 N 121st E Ave, Owasso, OK 74055, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "People say this department store offers a wide selection of designer jewelry, handbags, and household products. They also highlight the reasonable prices, efficient checkout process, and friendly cashiers.\n\nOther reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-554c-74d9-ac6e-2f8ff36f2a05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-554c-74d9-ac6e-2f8ff36f2a05",
        "storage_key": "property/6767906449167036/019d7917-554c-74d9-ac6e-2f8ff36f2a05.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=3359472303491495149&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "t-j-maxx-homegoods",
      "poi_latitude": "36.2905509",
      "poi_longitude": "-95.843086",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-274-9822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7fc-777b-a58b-7af39e9dc882",
        "storage_key": "property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF1KAWZzwtocR7bRfwkI-ny4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_06e28ef4-fa57-4f62-bc83-953e1105f71a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Shopping & Retail",
      "poi_address": "8959 N Garnett Rd, Owasso, OK 74055, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "People say this sporting goods store offers a wide selection of fishing gear and clearance fishing clothes. They also highlight the helpful and friendly staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-531b-70ed-b7ec-6deb9da00bef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-531b-70ed-b7ec-6deb9da00bef",
        "storage_key": "property/6767906449167036/019d7917-531b-70ed-b7ec-6deb9da00bef.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/oklahoma/owasso/store-0244",
      "poi_directions_map_url": "https://maps.google.com/?cid=16727263850299031197&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "academy-sports-outdoors",
      "poi_latitude": "36.2853677",
      "poi_longitude": "-95.84637080000002",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-295-1450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b7fc-777b-a58b-7af39e9dc882",
        "storage_key": "property/6767906449167036/019cfb50-b7fc-777b-a58b-7af39e9dc882.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPdPo8ILwtocRnX5O1dgtI-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_d66906bc-9162-4b06-88c3-51e4d3d2c7e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Tulsa Zoo",
      "poi_type": "Entertainment",
      "poi_address": "6421 E 36th St N, Tulsa, OK 74115, USA",
      "poi_short_description": "An expansive, educational park with a huge variety of animals, plus the Safari Train & a carousel.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, sea lions, and tigers, and has a dinosaur exhibit, carousel, and playground. They highlight the membership is worth it, especially for large groups, and the zoo is family-friendly. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-55a6-7429-ac5c-cd1b10a92f1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-55a6-7429-ac5c-cd1b10a92f1d",
        "storage_key": "property/6767906449167036/019d7917-55a6-7429-ac5c-cd1b10a92f1d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tulsazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10038979359347895889&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-zoo",
      "poi_latitude": "36.2130153",
      "poi_longitude": "-95.9064904",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-669-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjb_PwwXutocRUe5o3YmeUYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_219ee56e-9fa6-4cca-9849-5d199513b20a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Woody Guthrie Center",
      "poi_type": "Entertainment",
      "poi_address": "102 E Reconciliation Wy, Tulsa, OK 74103, USA",
      "poi_short_description": "Archives & exhibits related to the famed folk singer plus Dust Bowl-era & regional history displays.",
      "poi_long_description": "People say this museum offers a diverse collection of exhibits, including a popular Hip Hop exhibit, and a punk, rap, and rock n roll exhibit. They highlight the informative and engaging experience, and the well-done presentation of the exhibits. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-a39e-714f-8c2d-fc19afaf6b79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a39e-714f-8c2d-fc19afaf6b79",
        "storage_key": "property/6767906449167036/019cfb50-a39e-714f-8c2d-fc19afaf6b79.webp",
        "width": 674,
        "height": 957
      },
      "poi_business_url": "http://woodyguthriecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6859463959324375305&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "woody-guthrie-center",
      "poi_latitude": "36.1586125",
      "poi_longitude": "-95.9922848",
      "poi_miles_from_property": "18.1 mi",
      "poi_walking_minutes": "6 hours 36 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-574-2710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-bbc8-738c-ac26-174a182f56d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-bbc8-738c-ac26-174a182f56d8",
        "storage_key": "property/6767906449167036/019cfb50-bbc8-738c-ac26-174a182f56d8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Y436YLrtocRCbkfxSC2MV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_179438bf-ff4c-4d1f-ae39-91a1688a6580",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Gilcrease Museum",
      "poi_type": "Entertainment",
      "poi_address": "1400 N Gilcrease Museum Rd, Tulsa, OK 74127, USA",
      "poi_short_description": "Museum housing extensive collections of art & artifacts of the American West & Native Americans.",
      "poi_long_description": "People say this art museum offers thoughtfully curated exhibits that provide deep insight into American history, Native American art, and the history of the West. They highlight the beautiful and peaceful grounds, and the well-organized and engaging experience. They also like the knowledgeable and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-5b73-776c-a352-f50a7a26d613.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5b73-776c-a352-f50a7a26d613",
        "storage_key": "property/6767906449167036/019d7917-5b73-776c-a352-f50a7a26d613.webp",
        "width": 1280,
        "height": 736
      },
      "poi_business_url": "http://gilcrease.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13539514656066097772&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gilcrease-museum",
      "poi_latitude": "36.1742658",
      "poi_longitude": "-96.0210402",
      "poi_miles_from_property": "18.3 mi",
      "poi_walking_minutes": "6 hours 43 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 918-596-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-bbc8-738c-ac26-174a182f56d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-bbc8-738c-ac26-174a182f56d8",
        "storage_key": "property/6767906449167036/019cfb50-bbc8-738c-ac26-174a182f56d8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgf7O0rXrtocRbNIDItgE5rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_bb21c18c-ab46-4983-ba59-ab15c7f9cff5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "The Cave House",
      "poi_type": "Entertainment",
      "poi_address": "1623 Charles Page Blvd, Tulsa, OK 74127, USA",
      "poi_short_description": "false",
      "poi_long_description": "Visitors say this tourist attraction offers a unique and fascinating experience with its whimsical, cave-like exterior and quirky, eclectic interior. They also highlight the knowledgeable and passionate management who provides captivating tours, sharing stories about the house's history and rumored connections to prohibition-era tunnels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-6016-7799-b8d2-76641c8189a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6016-7799-b8d2-76641c8189a1",
        "storage_key": "property/6767906449167036/019d7917-6016-7799-b8d2-76641c8189a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cavehousetulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2036454794667285882&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-cave-house",
      "poi_latitude": "36.1517261",
      "poi_longitude": "-96.0112601",
      "poi_miles_from_property": "19.5 mi",
      "poi_walking_minutes": "7 hours 7 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 918-378-1952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT5fkfgzrtocRet1IndjwQhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_1e44a6ef-721b-4365-ad40-76be4384db45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Tulsa Air and Space Museum",
      "poi_type": "Entertainment",
      "poi_address": "3624 N 74th E Ave, Tulsa, OK 74115, USA",
      "poi_short_description": "Detailed history from 1897 to the space age plus interactive exhibits, vintage aircraft & a theater.",
      "poi_long_description": "People say this museum offers a variety of aircraft, interactive exhibits, and a planetarium. They also highlight the friendly and helpful staff, and the affordable admission.\n\nOther reviews mention some exhibits can be under repair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d7917-619e-72bf-ba9c-b21803a2bc76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-619e-72bf-ba9c-b21803a2bc76",
        "storage_key": "property/6767906449167036/019d7917-619e-72bf-ba9c-b21803a2bc76.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tulsamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16931592180727714246&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-air-and-space-museum",
      "poi_latitude": "36.2067509",
      "poi_longitude": "-95.8957281",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-834-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-bbc8-738c-ac26-174a182f56d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-bbc8-738c-ac26-174a182f56d8",
        "storage_key": "property/6767906449167036/019cfb50-bbc8-738c-ac26-174a182f56d8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJI9UUGf_xtocRxpEOhmEZ-eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6127d941-6cb4-4549-aa6e-ee8e088ba8c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Cain's Ballroom",
      "poi_type": "Entertainment",
      "poi_address": "423 N Main St, Tulsa, OK 74103, USA",
      "poi_short_description": "Famed 1924 dance hall & concert venue with a full bar presenting country, rock & other live bands.",
      "poi_long_description": "People say this live music venue offers a wide variety of drinks and BBQ, and hosts a diverse range of artists and bands. They highlight the historic atmosphere, excellent acoustics, and convenient parking. They also like the friendly staff and efficient service at the bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-a19e-70fe-a902-62862f70b988.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a19e-70fe-a902-62862f70b988",
        "storage_key": "property/6767906449167036/019cfb50-a19e-70fe-a902-62862f70b988.webp",
        "width": 1280,
        "height": 774
      },
      "poi_business_url": "http://www.cainsballroom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2392430961435331881&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cain-s-ballroom",
      "poi_latitude": "36.160996",
      "poi_longitude": "-95.994941",
      "poi_miles_from_property": "18.1 mi",
      "poi_walking_minutes": "6 hours 36 mins",
      "poi_biking_minutes": "1 hour 41 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-584-2306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b803-7034-b268-58815dc38200",
        "storage_key": "property/6767906449167036/019cfb50-b803-7034-b268-58815dc38200.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJebBVvpzrtocRKc3_pUifMyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_9fa7d1e8-969e-409a-b4af-185a28ab6abd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Bailey Education Group (Elementary Charter School)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "bailey-education-group-elementary-charter-school",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_11bc2c7a-46b4-48d0-9a01-0f0629bef838",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Owasso 6th, 7th, and 8th Grade Centers",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "owasso-6th-7th-and-8th-grade-centers",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b62a95f0-f331-4f8f-8dde-d6bc5d0bac25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Tulsa Technology Center Owasso Campus",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "tulsa-technology-center-owasso-campus",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7737bdc8-7779-4207-b0ed-af344c885f8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "The Flying Pig",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "the-flying-pig",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_233ab39a-1976-42fb-8875-b6e7b625d428",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "poi_name": "Bluestem Mercantile Owasso, OK",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "bluestem-mercantile-owasso-ok",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_196b10f47afbe8197e09f1fb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4a62a1e9d8a456540f732f55",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0c0b9248c7f490746f5b26fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a35423f244fc42ea39259980",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_df4cdd1f1a66e141dd063e5a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_79434c5d6ebc805f83ba4764",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_c3b3d4f4-ce49-43bf-81b8-63acc2f9846a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "rating": "5.0",
      "name": "Trey O'Neal",
      "text": "I’ve been really happy living here. The whole complex is well-kept, and the staff is genuinely friendly every time I’ve interacted with them. Maintenance has been great too—our AC went out once and they had it fixed very quickly, and even checked in to make sure we were comfortable in the meantime.\n\nIt’s also surprisingly quiet for an apartment complex. Most days you hear more nature sounds than anything else, which has been such a nice change of pace. Overall, it’s been a great place to live and I’m really happy with it!",
      "date": "2025-11-22",
      "title": ""
    },
    {
      "id": "custom_1598dab9-696b-42ea-a73e-8726c9fc424c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "rating": "5.0",
      "name": "Annmarie Smith",
      "text": "I am so glad a chose The Park at Coffee Creek. The office staff is amazing. I have had a few small maintenance things that were resolved quickly. It is quiet and peaceful. The only thing is I wish the dog park was a little bigger with some shade. That is my small recommendation!  I love it here.  This has created the peace I needed and is a fantastic place to live !",
      "date": "2025-08-21",
      "title": ""
    },
    {
      "id": "custom_1d8bb3a2-e4dd-4d9e-afe5-7dccf32c52ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "rating": "5.0",
      "name": "Megan Rector",
      "text": "Amazing management and staff!! I’ve lived here for 2 years and I have absolutely no complaints! Management team is fast and excellent. Everything is in great condition and kept up with. So sad to be leaving soon!! If I ever return to owasso, I will definitely be back in this complex!",
      "date": "2025-11-19",
      "title": ""
    },
    {
      "id": "custom_9919c309-807d-4f1f-962c-5485379b36be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "rating": "5.0",
      "name": "Don Allison",
      "text": "Excellent!!!\nWe have lived here for a year and a half. All services are professional, friendly, and timely. The facilities are always maintained. Maintenance was able to show up on a weekend in a few minutes to address an A/C concern and it was fixed in a few minutes. I have peace of mind knowing serious concerns get taken care of quickly and properly.\nIt is a peaceful community. I value peace and quiet and I get that here. I have total peace of mind knowing everything will be taken care of in a timely manner by professional and friendly people. I just renewed my lease for another year because of the high quality living experience it offers.",
      "date": "2025-07-22",
      "title": ""
    },
    {
      "id": "custom_8caade48-145c-4438-bc12-1c2b1180fed9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "rating": "5.0",
      "name": "Terri Eberhard",
      "text": "The replacement of my dishwasher could not have gone smoother. I really appreciate having your maintenance person coming to look at it quickly and the next day I had a very nice brand new one installed. He is a great guy and his actions were very professional and it couldn't have gone e smoother. I love living here. I'm starting my 2nd year.",
      "date": "2025-08-23",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_216e6ca7-1b8b-4f13-a5c3-4fe3305e6d80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb51-408a-770d-93c2-41d1f170d6cb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of apartment complex exterior with picnic area.",
        "public_id": "019cfb51-408a-770d-93c2-41d1f170d6cb",
        "storage_key": "property/6767906449167036/019cfb51-408a-770d-93c2-41d1f170d6cb.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Coffee Creek Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6304ceed3535377cb72ee6a4&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79d-ac07-71ce-9b28-0997c1f7d34d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "coffee-creek",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036"
    },
    {
      "lead_collector_id": "019cf79d-ac75-7479-a9cb-4f124667a9f4",
      "lead_source": "LANDING_PAGE",
      "name": "coffee-creek",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-owasso-ok-coffee-creek",
      "search_query": "pet friendly apartments in Owasso OK",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Owasso, OK",
      "h2_subtitle": "Discover our pet friendly community in Owasso, OK. Coffee Creek offers comfortable living spaces with amenities perfect for you and your furry friends.",
      "page_copy": "Welcome to Coffee Creek, where pet friendly apartments in Owasso, OK, provide a welcoming environment for both you and your pets. Our spacious layouts ensure that your four-legged companions have plenty of room to play and relax. With a vibrant community host to a picnic area complete with barbecue grills, you and your pets can enjoy delightful outdoor activities together. Nestled in the heart of Owasso, our community boasts easy access to local parks and trails, making Coffee Creek an ideal location for pet owners.\n\nAt Coffee Creek, we understand that pets are family. That's why our pet friendly apartments in Owasso, OK, come equipped with modern amenities such as air conditioning and large side-by-side refrigerators. We accept electronic payments to make your living experience even more convenient. Plus, our 24-hour emergency maintenance ensures that any service issues are handled promptly. Join our thriving community and enjoy a comfortable lifestyle tailored to you and your pets.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Owasso, OK | Coffee Creek",
      "seo_description": "Find the perfect pet friendly apartments in Owasso, OK, at Coffee Creek. Enjoy spacious homes with great amenities for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "generator",
      "page_item_url": "apartments-with-pool-tulsa-county-coffee-creek",
      "search_query": "apartments with a pool in Tulsa County",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Tulsa County",
      "h2_subtitle": "Discover Coffee Creek's apartments with a pool in Tulsa County. Enjoy refreshing swims in a welcoming community with top-tier amenities.",
      "page_copy": "Experience the best of Tulsa County living at Coffee Creek, where our apartments with a pool offer a perfect blend of relaxation and recreation. Situated in the vibrant neighborhood of Owasso, our community ensures that you have access to everything you need right at your doorstep. Dive into our sparkling pool after a long day and enjoy the serene atmosphere.\n\nMore than just great amenities, Coffee Creek apartments provide a home with thoughtful features such as air conditioning, large side-by-side refrigerators, and electronic payment systems. Whether you're hosting a barbecue at our picnic area or simply lounging by the pool, our apartments in Tulsa County offer a rejuvenating lifestyle. With 24-hour emergency maintenance services, we prioritize your convenience and peace of mind. Come see why Coffee Creek is the perfect place for those seeking apartments with a pool in Tulsa County!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Tulsa County | Coffee Creek",
      "seo_description": "Discover Coffee Creek's apartments with a pool in Tulsa County. Relax and enjoy our community amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "generator",
      "page_item_url": "washer-dryer-connections-apartments-near-74055",
      "search_query": "washer dryer connections apartments near 74055",
      "category": "Amenity",
      "h1_title": "Washer Dryer Connections Apartments Near 74055",
      "h2_subtitle": "Explore our apartments near 74055 with washer dryer connections. Coffee Creek offers the convenience you need in a vibrant Owasso community.",
      "page_copy": "At Coffee Creek, we provide comfortable living spaces with washer dryer connections apartments near 74055, perfect for those seeking convenience in their daily routines. Located in Owasso, our community ensures easy access to local amenities and attractions. Modern features like air conditioning and spacious kitchens with large side-by-side refrigerators complement our convenient in-home connections.\n\nChoose Coffee Creek for a lifestyle that blends convenience with comfort. Our community offers amenities such as a picnic area with barbecue grills and electronic payment options for hassle-free living. Enjoy the assurance of our 24-hour emergency maintenance services, dedicated to maintaining your peace of mind. Discover why our apartments near the 74055 area are ideal for residents seeking efficiency and style in Owasso.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer Dryer Connections Apartments Near 74055 | Coffee Creek",
      "seo_description": "Find convenient washer dryer connections apartments near 74055 at Coffee Creek. Enjoy modern living with great amenities in Owasso, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "generator",
      "page_item_url": "24-hour-fitness-center-apartments-owasso-coffee-creek",
      "search_query": "24 hour fitness center apartments Owasso",
      "category": "Amenity",
      "h1_title": "24 Hour Fitness Center Apartments in Owasso",
      "h2_subtitle": "Discover apartments in Owasso with a 24 hour fitness center. Coffee Creek offers you flexibility and convenience for an active lifestyle.",
      "page_copy": "Welcome to Coffee Creek, where our 24 hour fitness center apartments in Owasso provide the ultimate convenience for fitness enthusiasts. Our community understands the importance of maintaining your health goals, which is why we offer a fitness center open around the clock, ensuring that you can exercise on your schedule.\n\nLocated in the heart of Owasso, Coffee Creek also offers a range of modern amenities, including air conditioning, large side-by-side refrigerators, and a welcoming picnic area with barbecue grills. Enjoy peace of mind with our 24-hour emergency maintenance services and electronic payment options. Immerse yourself in a community that supports your active lifestyle and caters to your daily needs. Come and explore why Coffee Creek is the perfect choice for those seeking 24 hour fitness center apartments in Owasso.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24 Hour Fitness Center Apartments Owasso | Coffee Creek",
      "seo_description": "Explore Coffee Creek's 24 hour fitness center apartments in Owasso. Enjoy active living with top amenities right at home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "generator",
      "page_item_url": "apartment-with-dog-park-owasso-ok-coffee-creek",
      "search_query": "apartment with dog park Owasso OK",
      "category": "Amenity",
      "h1_title": "Apartment with Dog Park in Owasso, OK",
      "h2_subtitle": "Discover Coffee Creek's apartment with a dog park in Owasso, OK. Enjoy a pet-friendly community with ample space for your furry friends to play.",
      "page_copy": "Coffee Creek offers a welcoming apartment community in Owasso, OK, complete with a dedicated dog park, ensuring your pets feel right at home. Our pet-friendly environment allows your furry companions to run and play freely, fostering a joyous living experience for both you and your pet.\n\nIn addition to our dog park, residents enjoy modern amenities such as air conditioning, spacious kitchens with large side-by-side refrigerators, and a beautiful picnic area with barbecue grills. We prioritize convenience with features like electronic payment systems and 24-hour emergency maintenance. At Coffee Creek, discover the perfect blend of comfort and pet-friendly living in Owasso, OK, where both you and your four-legged friends can thrive.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Dog Park Owasso, OK | Coffee Creek",
      "seo_description": "Find your new home at Coffee Creek, an apartment with a dog park in Owasso, OK. Pet-friendly community with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "generator",
      "page_item_url": "one-bedroom-coffee-creek-apartments-owasso",
      "search_query": "one bedroom coffee creek apartments owasso",
      "category": "Floorplan",
      "h1_title": "One Bedroom Coffee Creek Apartments Owasso",
      "h2_subtitle": "Explore our stylish one bedroom Coffee Creek apartments in Owasso. Modern and spacious living spaces designed for your comfort and convenience.",
      "page_copy": "Discover the charm of one bedroom Coffee Creek apartments in Owasso, where style meets comfort. Our thoughtfully designed one-bedroom homes offer spacious layouts with modern amenities that cater to your lifestyle. Each apartment comes equipped with air conditioning and a large side-by-side refrigerator, ensuring a comfortable and convenient living environment.\n\nLocated in the vibrant community of Owasso, Coffee Creek offers a range of features including a picnic area with barbecue grills and electronic payment options, all supported by a dedicated 24-hour emergency maintenance team. These amenities make our apartments a perfect choice for individuals looking to enjoy a blend of comfort and modern living. Choose Coffee Creek for your one-bedroom apartment needs in Owasso, and experience a place you can truly call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Coffee Creek Apartments Owasso | Coffee Creek",
      "seo_description": "Discover one bedroom Coffee Creek apartments in Owasso, OK. Enjoy modern amenities and spacious living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-tulsa-county-ok-coffee-creek",
      "search_query": "two bedroom apartments tulsa county ok",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Tulsa County, OK",
      "h2_subtitle": "Explore spacious two bedroom apartments at Coffee Creek in Tulsa County, OK. Exceptional living with modern amenities and convenience.",
      "page_copy": "Welcome to Coffee Creek, where our two-bedroom apartments in Tulsa County, OK, offer the ideal blend of space and modern amenities. Each apartment features thoughtful layouts designed for comfort and functionality, ensuring you have all the space you need for living and entertaining.\n\nCoffee Creek boasts amenities such as air conditioning, large side-by-side refrigerators, and a community-focused picnic area with barbecue grills. Located conveniently in Owasso, within Tulsa County, our community is dedicated to providing residents with convenience and ease, highlighted by electronic payment options and 24-hour emergency maintenance. If you're seeking quality two-bedroom apartment living in Tulsa County, Coffee Creek is the perfect choice.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Tulsa County, OK | Coffee Creek",
      "seo_description": "Discover spacious two bedroom apartments in Tulsa County at Coffee Creek. Enjoy modern living with excellent community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "generator",
      "page_item_url": "apartments-near-ascension-st-john-owasso-coffee-creek",
      "search_query": "apartments near Ascension St. John Owasso Owasso OK",
      "category": "Hospital",
      "h1_title": "Apartments Near Ascension St. John Owasso",
      "h2_subtitle": "Discover convenient living at Coffee Creek, offering apartments near Ascension St. John Owasso in Owasso, OK. Enjoy proximity and comfort.",
      "page_copy": "Coffee Creek provides ideal apartment living options near Ascension St. John Owasso, located in the heart of Owasso, OK. Our community not only offers close proximity to this esteemed medical facility but also features amenities designed to make your life easier and more enjoyable.\n\nResidents enjoy fully air-conditioned apartments, large side-by-side refrigerators for ample food storage, and a scenic picnic area with barbecue grills perfect for gatherings. Electronic payment options add convenience to your monthly routine, and with our 24-hour emergency maintenance team, you can rest easy knowing help is always nearby. Choose Coffee Creek for luxurious and convenient living close to Ascension St. John Owasso.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ascension St. John Owasso, OK | Coffee Creek",
      "seo_description": "Find convenient apartments near Ascension St. John Owasso in Owasso, OK. Discover comfort and modern amenities at Coffee Creek.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "generator",
      "page_item_url": "apartments-close-to-warren-clinic-urgent-care-74055",
      "search_query": "apartments close to Warren Clinic Urgent Care 74055",
      "category": "Hospital",
      "h1_title": "Apartments Close to Warren Clinic Urgent Care",
      "h2_subtitle": "Discover Coffee Creek, located close to Warren Clinic Urgent Care in the 74055 area. Enjoy a convenient and comfortable living experience.",
      "page_copy": "At Coffee Creek, enjoy the convenience of living in apartments close to Warren Clinic Urgent Care, located in the vibrant 74055 area. Our community combines modern amenities with a prime location, making it the perfect choice for those seeking both accessibility and comfort.\n\nLife at Coffee Creek means benefiting from features like air conditioning, spacious side-by-side refrigerators, and a delightful picnic area complete with barbecue grills. Our community is tailored for the modern resident, offering electronic payment options and reliable 24-hour emergency maintenance services. Choose Coffee Creek for a convenient lifestyle just steps away from essential services like Warren Clinic Urgent Care.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Warren Clinic Urgent Care | Coffee Creek",
      "seo_description": "Live near Warren Clinic Urgent Care in the 74055 area. Coffee Creek offers modern living with convenient access and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "generator",
      "page_item_url": "apartments-near-funtastic-island-owasso-coffee-creek",
      "search_query": "apartments near Funtastic Island Owasso",
      "category": "Park",
      "h1_title": "Apartments Near Funtastic Island Owasso",
      "h2_subtitle": "Just minutes from Funtastic Island, Coffee Creek offers perfect apartments in Owasso. Ideal for those seeking fun and convenience.",
      "page_copy": "Living at Coffee Creek means having your apartment near Funtastic Island, a popular attraction in Owasso. Our community offers a harmonious blend of modern living and recreational proximity, ensuring that fun is always within reach.\n\nOur amenities include air conditioning, large side-by-side refrigerators, and a community picnic area with barbecue grills, perfect for family and friend gatherings. With electronic payment options and vigilant 24-hour emergency maintenance, Coffee Creek is designed for hassle-free living. Choose our apartments for the perfect balance between leisure and practicality, just a stone’s throw from Funtastic Island in Owasso.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Funtastic Island Owasso | Coffee Creek",
      "seo_description": "Experience fun and convenience with Coffee Creek apartments near Funtastic Island in Owasso. Enjoy modern amenities and recreation nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "generator",
      "page_item_url": "apartments-close-to-centennial-park-74055-coffee-creek",
      "search_query": "apartments close to Centennial Park 74055",
      "category": "Park",
      "h1_title": "Apartments Close to Centennial Park 74055",
      "h2_subtitle": "Live near Centennial Park in the welcoming 74055 area. Enjoy the excellent location of Coffee Creek apartments, combining comfort and nature.",
      "page_copy": "At Coffee Creek, find the perfect harmony of modern living and natural beauty with our apartments close to Centennial Park in the 74055 area. Embrace an active lifestyle or a peaceful retreat with the park just a short distance away.\n\nOur community offers features such as air conditioning and large side-by-side refrigerators to enhance your living experience. Enjoy leisure time in our picnic area with barbecue grills, ideal for socializing with friends and family. With electronic payment options and a dedicated 24-hour emergency maintenance team, living is hassle-free. Choose Coffee Creek for the ultimate convenience and serenity near Centennial Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Centennial Park 74055 | Coffee Creek",
      "seo_description": "Discover Coffee Creek apartments near Centennial Park in the 74055 area. Enjoy modern conveniences and an excellent location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167036",
      "source": "generator",
      "page_item_url": "apartments-by-rayola-park-tulsa-county-coffee-creek",
      "search_query": "apartments by Rayola Park Tulsa County",
      "category": "Park",
      "h1_title": "Apartments by Rayola Park, Tulsa County",
      "h2_subtitle": "Coffee Creek offers prime living near Rayola Park in Tulsa County. Discover a perfect blend of comfort and outdoor adventure.",
      "page_copy": "Find your new home at Coffee Creek, featuring apartments by Rayola Park in beautiful Tulsa County. Rayola Park offers lush green spaces and recreational opportunities for a vibrant outdoor lifestyle.\n\nOur community provides residents with quality amenities, including air conditioning, large side-by-side refrigerators, and a charming picnic area with barbecue grills. We ensure convenience with electronic payment systems and round-the-clock emergency maintenance services. At Coffee Creek, enjoy seamless living paired with easy access to the natural wonders of Rayola Park. Experience a balanced lifestyle that integrates comfort and recreation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Rayola Park Tulsa County | Coffee Creek",
      "seo_description": "Live near Rayola Park in Tulsa County at Coffee Creek. Enjoy modern amenities and outdoor adventures in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5159"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-72H3M68L0H"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041150935"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/coffee-creek/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W3DTF6NG"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449167036/019d1bd7-9504-77ea-bb1f-65240dd9a125.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "a59772ba-0534-4e9d-93c3-dc0a88013b02"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-578-2137"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64418532c13f36b6699ca9a3"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlRXdHZsTTRqazVKcWMycjY4WVJWZlE9PSIsInZhbHVlIjoibFI1dEQ0U0tudm10M1VaWEhsZXhRQT09IiwibWFjIjoiMjA3ZTQyMDFjYmU2MDYwZDViMDFkODc1ZjgzODc2MTk4ZjgzMDg3ZmU4ZTA5NWYzNmU2NTI5OTgwODg4Mjk2NSJ9"
    }
  ],
  "custom_qb_id": "5159",
  "custom_ga4_id": "G-72H3M68L0H",
  "custom_repli_id": "10041150935",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/coffee-creek/register/",
  "custom_google_gtm_id": "GTM-W3DTF6NG",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449167036/019d1bd7-9504-77ea-bb1f-65240dd9a125.pdf",
  "custom_rentgrata_property_id": "a59772ba-0534-4e9d-93c3-dc0a88013b02",
  "custom_ppc_tracking_phone_number": "800-578-2137",
  "custom_residentboost_apartment_id": "64418532c13f36b6699ca9a3",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlRXdHZsTTRqazVKcWMycjY4WVJWZlE9PSIsInZhbHVlIjoibFI1dEQ0U0tudm10M1VaWEhsZXhRQT09IiwibWFjIjoiMjA3ZTQyMDFjYmU2MDYwZDViMDFkODc1ZjgzODc2MTk4ZjgzMDg3ZmU4ZTA5NWYzNmU2NTI5OTgwODg4Mjk2NSJ9"
};

export const generatedAt = '2026-08-27T21:33:36.843Z';
